/* ==========================================================================
   Lockett Labs, live card data for the product page (assets/ll-card-data.js)

   Moved out of snippets/pdp-card-data.liquid on 29 Sep 2026, unchanged in
   what it does: it was ~75 KB of inline script sent with every single-card
   page and is now cached once. The snippet still renders the config
   ([data-tcg-config]) and the panel ([data-tcg]); this finds them from the
   config block rather than from the section id it used to be templated with.
   Loaded with defer by sections/static-product.liquid, only when a card
   lookup applies (tcg_ok).
   ========================================================================== */
(function () {
  var cfgEl = document.querySelector('[data-tcg-config]');
  var root = cfgEl && (cfgEl.closest('.shopify-section') || cfgEl.parentElement);
  if (!root) return;
  var el = root.querySelector('[data-tcg]');
  if (!el || !cfgEl || !window.fetch) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  var BASE = 'https://api.tcgdex.net/v2/';
  var BASE_MM = 'https://api.mymemory.translated.net/get';
  /* Query ONLY the product's own language database — never cross-match EN <-> JP.
     Cross-language fallback is exactly what pulled the wrong card. */
  var LANGS = [cfg.lang || 'en'];
  /* TCGdex "category" is "Pokemon" / "Trainer" / "Energy" (no accent) — encoding-safe. */
  function isPokemon(c) { return /^pok/i.test(c.category || ''); }
  /* Japanese-text detector by code point (hiragana / katakana / CJK / half-width) —
     uses numeric ranges, no CJK source literals, so it is encoding-safe. */
  function hasJP(s) {
    s = String(s || '');
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      if ((c >= 0x3040 && c <= 0x30ff) || (c >= 0x3400 && c <= 0x9fff) || (c >= 0xff66 && c <= 0xff9f)) return true;
    }
    return false;
  }
  function slugify(s) { return String(s || '').trim().toLowerCase().replace(/&/g, 'and').replace(/['’.]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  /* ---- Pokéllector set-symbol images (den-media.pokellector.com), keyed by the
     English set-name slug. TCGdex has no set symbols for Japanese sets; pokellector
     does, and its images hotlink cross-origin (no CORS needed for <img>). Baked
     slug -> [exactSlug, id] map — refresh from jp.pokellector.com/sets. ---- */
  var PK = {"20th-anniversary-collection":["20th-Anniversary-Collection",198],"25th-anniversary-collection":["25th-Anniversary-Collection",327],"25th-anniversary-promo-pack":["25th-Anniversary-Promo-Pack",328],"30th-celebration-japanese":["30th-Celebration-Japanese",435],"30th-celebration":["30th-Celebration",434],"abyss-eye":["Abyss-Eye",433],"advent-of-arceus":["Advent-of-Arceus",256],"alola-moonlight":["Alola-Moonlight",210],"alter-genesis":["Alter-Genesis",281],"ancient-roar":["Ancient-Roar",381],"ascended-heroes":["Ascended-Heroes",426],"ash-vs-team-rocket-battle-set":["Ash-vs-Team-Rocket-Battle-Set",221],"awakening-legends":["Awakening-Legends",332],"awakening-of-psychic-kings":["Awakening-of-Psychic-Kings",184],"bandit-ring":["Bandit-Ring",171],"battle-partners":["Battle-Partners",408],"battle-region":["Battle-Region",339],"beat-of-the-frontier":["Beat-of-the-Frontier",255],"black-bolt":["Black-Bolt",414],"black-collection":["Black-Collection",14],"black-white-promos":["Black-White-Promos",25],"blastoise-kyurem-combo-deck":["Blastoise-Kyurem-Combo-Deck",126],"blue-impact":["Blue-Impact",176],"blue-sky-stream":["Blue-Sky-Stream",319],"bonds-to-the-end-of-time":["Bonds-to-the-End-of-Time",254],"challenge-from-the-darkness":["Challenge-from-the-Darkness",317],"champion-road":["Champion-Road",237],"chaos-rising":["Chaos-Rising",431],"charisma-of-the-cracked-sky":["Charisma-of-the-Cracked-Sky",242],"clash-at-the-summit":["Clash-at-the-Summit",250],"clay-burst":["Clay-Burst",370],"cold-flare":["Cold-Flare",23],"collection-moon":["Collection-Moon",202],"collection-sun":["Collection-Sun",201],"collection-x":["Collection-X",139],"collection-y":["Collection-Y",140],"crimson-haze":["Crimson-Haze",391],"crossing-the-ruins":["Crossing-the-Ruins",331],"cyber-judge":["Cyber-Judge",387],"dp-promos":["DP-Promos",274],"dpt-promos":["DPt-Promos",136],"dark-order":["Dark-Order",245],"dark-phantasma":["Dark-Phantasma",343],"dark-rush":["Dark-Rush",20],"darkness-and-to-light":["Darkness-and-to-Light",333],"detective-pikachu":["Detective-Pikachu",271],"double-blaze":["Double-Blaze",266],"dragon-blade":["Dragon-Blade",21],"dragon-blast":["Dragon-Blast",22],"dragon-selection":["Dragon-Selection",16],"dragon-storm":["Dragon-Storm",236],"dream-league":["Dream-League",278],"ex-battle-boost":["EX-Battle-Boost",129],"eevee-heroes-vmax-special-set":["Eevee-Heroes-VMAX-Special-Set",330],"eevee-heroes":["Eevee-Heroes",322],"electrifying-tackle":["Electrifying-Tackle",297],"emerald-break":["Emerald-Break",167],"exciting-battle-for-everyone":["Exciting-Battle-for-Everyone",30],"expansion-pack":["Expansion-Pack",311],"explosive-flame-walker":["Explosive-Flame-Walker",295],"explosive-impact":["Explosive-Impact",258],"explosive-warrior":["Explosive-Warrior",194],"fairy-rise":["Fairy-Rise",240],"forbidden-light":["Forbidden-Light",235],"freeze-bolt":["Freeze-Bolt",24],"full-metal-wall":["Full-Metal-Wall",263],"fusion-arts":["Fusion-ARTS",326],"future-flash":["Future-Flash",382],"gg-end":["GG-End",267],"gx-battle-boost":["GX-Battle-Boost",228],"gaia-volcano":["Gaia-Volcano",165],"galactics-conquest":["Galactics-Conquest",253],"garchomp-half-deck":["Garchomp-Half-Deck",134],"glory-of-team-rocket":["Glory-of-Team-Rocket",413],"gold-silver-to-a-new-world":["Gold-Silver-to-a-New-World",324],"golduck-palkia-ex-break-combo-deck":["Golduck-Palkia-EX-BREAK-Combo-Deck",178],"hail-blizzard":["Hail-Blizzard",18],"heartgold-collection":["HeartGold-Collection",247],"hot-air-arena":["Hot-Air-Arena",411],"hydreigon-half-deck":["Hydreigon-Half-Deck",135],"hyper-metal-chain-deck":["Hyper-Metal-Chain-Deck",163],"incandescent-arcana":["Incandescent-Arcana",352],"inferno-x":["Inferno-X",425],"infinity-zone":["Infinity-Zone",293],"islands-awaiting-you":["Islands-Awaiting-You",211],"jet-black-poltergeist":["Jet-Black-Poltergeist",310],"keldeo-battle-strength-deck":["Keldeo-Battle-Strength-Deck",133],"leaders-stadium":["Leaders-Stadium",316],"legendary-holo-collection":["Legendary-Holo-Collection",173],"legendary-pulse":["Legendary-Pulse",294],"light-consuming-darkness":["Light-Consuming-Darkness",218],"lost-abyss":["Lost-Abyss",344],"lost-link":["Lost-Link",251],"m-charizard-ex-mega-battle-deck":["M-Charizard-EX-Mega-Battle-Deck",156],"mega-dream-ex":["MEGA-Dream-ex",427],"mask-of-change":["Mask-of-Change",393],"matchless-fighter":["Matchless-Fighter",308],"mega-audino-ex-mega-battle-deck":["Mega-Audino-EX-Mega-Battle-Deck",190],"mega-brave":["Mega-Brave",416],"mega-evolution-energies":["Mega-Evolution-Energies",436],"mega-evolution":["Mega-Evolution",422],"mega-rayquaza-ex-battle-deck":["Mega-Rayquaza-EX-Battle-Deck",170],"mega-series-promos":["Mega-Series-Promos",419],"mega-symphonia":["Mega-Symphonia",417],"megalo-cannon":["Megalo-Cannon",29],"mewtwo-vs-genesect-genesect":["Mewtwo-Vs-Genesect-Genesect",145],"mewtwo-vs-genesect-mewtwo":["Mewtwo-Vs-Genesect-Mewtwo",144],"miracle-twins":["Miracle-Twins",277],"munikis-zero":["Munikis-Zero",428],"mystery-of-the-fossils":["Mystery-of-the-Fossils",314],"mythical-legendary-dream-holo-collection":["Mythical-Legendary-Dream-Holo-Collection",195],"night-unison":["Night-Unison",262],"night-wanderer":["Night-Wanderer",398],"ninja-spinner":["Ninja-Spinner",430],"noivern-break-evolution-pack":["Noivern-BREAK-Evolution-Pack",181],"ppp-promos":["PPP-Promos",128],"paradigm-trigger":["Paradigm-Trigger",351],"paradise-dragona":["Paradise-Dragona",403],"perfect-order":["Perfect-Order",429],"perfect-skyscraper":["Perfect-Skyscraper",318],"phantasmal-flames":["Phantasmal-Flames",424],"phantom-gate":["Phantom-Gate",160],"pikachu-new-friends":["Pikachu-New-Friends",204],"pitch-black":["Pitch-Black",432],"plasma-gale":["Plasma-Gale",12],"pokekyun-collection":["Pokekyun-Collection",186],"pokemon-151":["Pokemon-151",371],"pokemon-card-game-starter-pack":["Pokemon-Card-Game-Starter-Pack",189],"pokemon-jungle":["Pokemon-Jungle",313],"pokemon-vs":["Pokemon-VS",276],"pokmon-go":["Pokmon-GO",347],"premium-champion-pack-ex-x-m-x-break":["Premium-Champion-Pack-EX-x-M-x-BREAK",185],"premium-trainer-box":["Premium-Trainer-Box",213],"psycho-drive":["Psycho-Drive",19],"rage-of-the-broken-sky":["Rage-of-the-Broken-Sky",177],"raging-surf":["Raging-Surf",376],"raichu-break-deck":["Raichu-BREAK-Deck",180],"rapid-strike-master":["Rapid-Strike-Master",307],"rebellion-crash":["Rebellion-Crash",291],"red-collection":["Red-Collection",17],"red-flash":["Red-Flash",175],"remix-bout":["Remix-Bout",272],"reviving-legends":["Reviving-Legends",249],"rising-fist":["Rising-Fist",157],"rocket-gang":["Rocket-Gang",315],"rockruff-complete-deck":["Rockruff-Complete-Deck",206],"ruler-of-the-black-flame":["Ruler-of-the-Black-Flame",368],"ruthless-rebel":["Ruthless-Rebel",193],"scarlet-violet-promos":["Scarlet-Violet-Promos",360],"scarlet-ex":["Scarlet-ex",361],"seen-the-rainbow-battle":["Seen-the-Rainbow-Battle",219],"shaymin-lvx-collection-pack":["Shaymin-LVX-Collection-Pack",151],"shield":["Shield",284],"shiny-collection":["Shiny-Collection",32],"shiny-star-v":["Shiny-Star-V",301],"shiny-treasure-ex":["Shiny-Treasure-ex",375],"silver-lance-jet-black-poltergeist-promo-set":["Silver-Lance-Jet-Black-Poltergeist-Promo-Set",321],"silver-lance":["Silver-Lance",309],"single-strike-master":["Single-Strike-Master",306],"sky-legends":["Sky-Legends",268],"snow-hazard":["Snow-Hazard",369],"soulsilver-collection":["SoulSilver-Collection",248],"space-juggler":["Space-Juggler",342],"spiral-force":["Spiral-Force",27],"star-birth":["Star-Birth",336],"start-deck-100":["Start-Deck-100",337],"starter-set-decks":["Starter-Set-Decks",208],"starter-set-tapu-bulu-gx":["Starter-Set-Tapu-Bulu-GX",222],"stella-miracle":["Stella-Miracle",401],"strengthening-expansion-pack-beyond-a-new-challenge":["Strengthening-Expansion-Pack-Beyond-A-New-Challenge",212],"strengthening-expansion-pack-shining-legends":["Strengthening-Expansion-Pack-Shining-Legends",224],"sun-moon-promos":["Sun-Moon-Promos",203],"sun-moon-strengthening-expansion":["Sun-Moon-Strengthening-Expansion",200],"super-electric-breaker":["Super-Electric-Breaker",405],"sword-shield-promos":["Sword-Shield-Promos",289],"sword":["Sword",283],"tag-bolt":["Tag-Bolt",260],"tag-team-gx-all-stars":["Tag-Team-GX-All-Stars",288],"team-magma-vs-team-aqua-double-crisis":["Team-Magma-vs-Team-Aqua-Double-Crisis",168],"team-plasma-battle-gift-set":["Team-Plasma-Battle-Gift-Set",31],"terastal-festival-ex":["Terastal-Festival-ex",406],"the-awoken-hero":["The-Awoken-Hero",226],"the-best-of-xy":["The-Best-of-XY",223],"the-town-on-no-map":["The-Town-on-No-Map",390],"the-transdimensional-beast":["The-Transdimensional-Beast",227],"thunder-knuckle":["Thunder-Knuckle",28],"thunderclap-spark":["Thunderclap-Spark",243],"tidal-storm":["Tidal-Storm",164],"time-gazer":["Time-Gazer",341],"triple-beat":["Triple-Beat",366],"ultra-force":["Ultra-Force",238],"ultra-moon":["Ultra-Moon",233],"ultra-shiny-gx":["Ultra-Shiny-GX",241],"ultra-sun":["Ultra-Sun",232],"v-rising":["V-Rising",285],"vmax-climax":["VMAX-Climax",338],"vmax-special-set":["VMAX-Special-Set",302],"vstar-universe":["VSTAR-Universe",357],"vending-series-2-red":["Vending-Series-2-Red",396],"vending-series-3-green":["Vending-Series-3-Green",397],"vending-series-blue":["Vending-Series-Blue",395],"violet-ex":["Violet-ex",362],"white-collection":["White-Collection",15],"white-flare":["White-Flare",415],"wild-blaze":["Wild-Blaze",152],"wild-force":["Wild-Force",386],"xy-beginning-set":["XY-Beginning-Set",146],"xy-promos":["XY-Promos",141],"xerneas-half-deck":["Xerneas-Half-Deck",154],"yveltal-half-deck":["Yveltal-Half-Deck",153],"zygarde-ex-perfect-battle-deck":["Zygarde-EX-Perfect-Battle-Deck",191]};
  /* TCGdex names the promo sets "SVP Black Star Promos"; Pokéllector files the
     same symbols under the series name. Both were verified to serve on
     2026-09-05, so this alias is the difference between a promo showing its set
     symbol and showing none: TCGdex publishes no symbol asset for any promo
     set, and the constructed fallback URL 404s. */
  var PK_ALIAS = {
    'svp-black-star-promos': 'scarlet-violet-promos',
    'swsh-black-star-promos': 'sword-shield-promos',
    'sm-black-star-promos': 'sun-moon-promos',
    'xy-black-star-promos': 'xy-promos',
    'bw-black-star-promos': 'black-white-promos',
    'mep-black-star-promos': 'mega-series-promos'
  };
  /* Which set name to show, in ONE place.

     The title's name normally wins: it is the English printing this shop sells
     and it stays English on a Japanese card. A promo title is the exception. It
     says only "PROMO", which is not a set name, reads as one in the panel, and
     matches nothing in the symbol map, so the card's resolved set is the more
     accurate answer ("SVP Black Star Promos").

     This lives here because the rule is needed twice, by the card-details
     header and by the set line beside the price, and those two had already
     drifted: the header said "SVP Black Star Promos" with a symbol while the
     buy box said "PROMO" with none, on the same card. */
  /* ---- sets named by a store tag ----
     Some products say which set they belong to only through a tag. The 30th
     Celebration uploads are tagged "30th ANNIVERSARY COLLECTION", but their
     titles name the set inconsistently ("30TH CELEBRATION", "30TH COLLECTION",
     or just "PROMO" on the Pokémon Center stamped promos such as Nidorina
     MEP101), and a card found by number can come back from an older set that
     shares the number (Magikarp 203/193 resolves to Paldea Evolved). For a
     tagged product the tag wins: the set line by the price, the card-details
     header and their symbol all read the tagged set. To cover a future set,
     add its tag (lower case) and the set name to this map. */
  var SET_BY_TAG = {
    '30th anniversary collection': '30th Celebration',
    '30th celebration': '30th Celebration'
  };
  var TAG_SET = (function () {
    var tags = cfg.tags || [];
    for (var i = 0; i < tags.length; i++) {
      var k = String(tags[i] || '').toLowerCase().replace(/\s+/g, ' ').trim();
      if (SET_BY_TAG[k]) return SET_BY_TAG[k];
    }
    return '';
  })();

  function preferredSetName(apiName) {
    if (TAG_SET) return TAG_SET;
    var t = TP.setName;
    if (t && !/^(promo|promos|promo card|holo|reverse holo)$/i.test(t)) return t;
    return apiName || t || '';
  }

  function pkSymbol(setNameEn) {
    var key = slugify(setNameEn);
    if (!key) return '';
    if (PK_ALIAS[key]) key = PK_ALIAS[key];
    var cands = [key, key.replace(/-base$/, ''), key.replace(/-jp$/, ''), key.replace(/-(promo|holo|reverse|deck).*$/, '')];
    for (var i = 0; i < cands.length; i++) {
      var v = PK[cands[i]];
      if (v) return 'https://den-media.pokellector.com/logos/' + v[0] + '.symbol.' + v[1] + '.png';
    }
    return '';
  }

  /* ---- Japanese -> English machine translation (MyMemory: free, keyless, CORS).
     A no-op for non-Japanese text, so English cards make zero requests. Each string
     is cached in localStorage (translations are reused across cards). ---- */
  function translate(text) {
    text = String(text || '');
    if (!text || !hasJP(text)) return Promise.resolve(text);
    var ck = 'll_tr_' + text;
    try { var hit = localStorage.getItem(ck); if (hit != null) return Promise.resolve(hit); } catch (e) {}
    var url = BASE_MM + '?langpair=ja|en&q=' + encodeURIComponent(text) + (cfg.mmEmail ? '&de=' + encodeURIComponent(cfg.mmEmail) : '');
    return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var t = j && j.responseData && j.responseData.translatedText;
      if (!t || /NO QUERY|INVALID|QUERY LENGTH LIMIT|MYMEMORY WARNING/i.test(t)) return text;
      try { localStorage.setItem(ck, t); } catch (e) {}
      return t;
    }).catch(function () { return text; });
  }
  function translateCard(card) {
    var did = false, jobs = [];
    function tf(obj, key) { var v = obj[key]; if (v && hasJP(v)) { did = true; jobs.push(translate(v).then(function (t) { obj[key] = t; })); } }
    (card.abilities || []).forEach(function (a) { tf(a, 'name'); tf(a, 'effect'); });
    (card.attacks || []).forEach(function (a) { tf(a, 'name'); tf(a, 'effect'); });
    tf(card, 'effect');
    return Promise.all(jobs).then(function () { return did; });
  }

  /* ---- energy-type symbols (self-contained inline SVG, crisp at any size).
     TCGdex uses the same English type names as the card frame. ---- */
  var EN = {
    Grass:     { c: '#5aab5a', g: '#fff',    d: 'M6 18C6 11 11 6.4 18 6c0 7-5 12-12 12z' },
    Fire:      { c: '#e2622f', g: '#fff',    d: 'M12 3.6c.6 3.1 4 4.3 4 7.6a4 4 0 0 1-8 0c0-1.4.7-2.5 1.5-3.1 0 1 .8 1.6 1.5 1.3 1-.5.2-2.6 1-6.8z' },
    Water:     { c: '#3f8bd4', g: '#fff',    d: 'M12 3.6c3.2 4.3 5 6.5 5 9.3a5 5 0 0 1-10 0c0-2.8 1.8-5 5-9.3z' },
    Lightning: { c: '#f5c518', g: '#6b4e00', d: 'M13.4 3 6 13.3h4.2L9 21l8-11.1h-4.6z' },
    Psychic:   { c: '#a35fb5', g: '#fff', ev: 1, d: 'M12 7.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zm0 2.7a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8z' },
    Fighting:  { c: '#c8702f', g: '#fff',    d: 'M8.2 10.8h7.6v3.4a3.4 3.4 0 0 1-3.4 3.4h-.8a3.4 3.4 0 0 1-3.4-3.4zM8.2 12.2c-1.1 0-1.7-.6-1.7-1.4s.7-1.3 1.7-1.1z' },
    Darkness:  { c: '#3f4a63', g: '#fff',    d: 'M13.2 5a7 7 0 1 0 4 12.2A5.7 5.7 0 0 1 13.2 5z' },
    Metal:     { c: '#8f9ea9', g: '#fff',    d: 'M12 4.2l1.5 2.9 3.2-.7-.7 3.2 2.9 1.5-2.9 1.5.7 3.2-3.2-.7L12 19.8l-1.5-2.9-3.2.7.7-3.2L5.1 12.9l2.9-1.5-.7-3.2 3.2.7z' },
    Fairy:     { c: '#e46fb0', g: '#fff',    d: 'M12 3.8c.9 4.3 2.1 5.5 6.4 6.4-4.3.9-5.5 2.1-6.4 6.4-.9-4.3-2.1-5.5-6.4-6.4 4.3-.9 5.5-2.1 6.4-6.4z' },
    Dragon:    { c: '#c9a227', g: '#fff',    d: 'M12 4l6 4.6L12 20 6 8.6z' },
    Colorless: { c: '#d9d4c9', g: '#6f6759', d: 'M12 4.4l2.2 4.8 5.3.6-4 3.6 1.1 5.2L12 16.1l-4.7 2.9 1.1-5.2-4-3.6 5.3-.6z' }
  };
  function energyIco(type, inText) {
    var e = EN[type] || EN.Colorless;
    return '<svg class="ll-tcg__en' + (inText ? ' ll-tcg__en--in' : '') + '" viewBox="0 0 24 24" role="img" aria-label="' + esc(type || 'Colorless') + '">' +
      '<circle cx="12" cy="12" r="11" fill="' + e.c + '" stroke="rgba(0,0,0,.18)" stroke-width="1"/>' +
      '<path d="' + e.d + '" fill="' + e.g + '"' + (e.ev ? ' fill-rule="evenodd"' : '') + '/></svg>';
  }

  /* ---- rules text. Some sets arrive marked up (so far the 30th Celebration
     sets): an energy word as <span class="energy-symbol Lightning" ...>Lightning</span>
     and reminder text as <em>. Passed through esc() whole, the tags were printed
     on the page. The text between tags is still escaped; energy spans become the
     symbol, as on the printed card, em/i stay italic (closed before the end, so an
     unclosed one cannot leak into the next block) and any other tag is dropped
     with its text kept. fxText() is the plain version for prose. ---- */
  var FX_TAG = /<span\b([^>]*)>([^<]*)<\/span>|<(\/?)(?:em|i)\b[^>]*>|<br\s*\/?>|<[^>]*>/gi;
  function fxHtml(s) {
    s = String(s == null ? '' : s);
    var out = '', last = 0, open = 0, m;
    FX_TAG.lastIndex = 0;
    while ((m = FX_TAG.exec(s))) {
      out += esc(s.slice(last, m.index));
      last = FX_TAG.lastIndex;
      if (m[1] != null) {
        var kind = /\benergy-symbol\b/.test(m[1]) && (m[1].match(/[A-Z][a-z]+/g) || []).filter(function (t) { return EN[t]; })[0];
        out += kind ? energyIco(kind, true) : esc(m[2]);
      } else if (m[3] != null) {
        if (!m[3]) { open++; out += '<em>'; } else if (open) { open--; out += '</em>'; }
      } else if (/^<br/i.test(m[0])) out += '<br>';
    }
    out += esc(s.slice(last));
    while (open-- > 0) out += '</em>';
    return out;
  }
  function fxText(s) {
    return String(s == null ? '' : s).replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '');
  }

  /* ---- fetch a full card by TCGdex id, trying preferred languages in order.
     Returns { card, lang } or null. ---- */
  function fetchCard(id) {
    return LANGS.reduce(function (pr, lang) {
      return pr.then(function (res) {
        if (res) return res;
        return fetch(BASE + lang + '/cards/' + encodeURIComponent(id))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (card) { return card && card.id ? { card: card, lang: lang } : null; })
          .catch(function () { return null; });
      });
    }, Promise.resolve(null));
  }

  /* ---- search one language by name, return the id of the entry whose collector
     number matches (or the first result when no number is known). ---- */
  function searchId(lang, name, number) {
    return fetch(BASE + lang + '/cards?name=' + encodeURIComponent(name))
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (arr) {
        if (!Array.isArray(arr) || !arr.length) return null;
        if (number) {
          var want = String(parseInt(number, 10));
          for (var i = 0; i < arr.length; i++) {
            if (String(parseInt(arr[i].localId, 10)) === want) return arr[i].id;
          }
          return null; /* number known but no match -> don't guess a wrong print */
        }
        return arr[0].id;
      })
      .catch(function () { return null; });
  }

  /* ---- pull "<name>.<SETCODE>.<NUM>.<hash>.<ext>" out of an image filename.
     Those set codes ARE TCGdex set ids (S12A, SV10, S6K, SV11W ...). ---- */
  function codeFromImages(images) {
    /* `[^.]*` after the trailing id is doing real work. Shopify appends a
       uniqueness suffix when a filename collides on upload, so
       "Venusaur-Celebi-GX.SM9.1.25429.webp" is stored as
       "Venusaur-Celebi-GX.SM9.1.25429_606e7a6b-acdf-....webp". The old pattern
       required the id to be followed immediately by the extension, so any
       product that had ever been re-uploaded silently stopped matching.

       That is not an edge case. Of 137 Japanese products with a code-shaped
       filename, this pattern matched 3; with the suffix allowed it matches 135.
       Japanese cards resolve by this code or not at all, because the title
       steps are English-only, so nearly every Japanese card on the site was
       showing no card data for this one reason. */
    var re = /\.([A-Za-z]{1,3}\d{1,3}[A-Za-z]?)\.(\d{1,3}[A-Za-z]?)\.\d+[^.]*\.(?:webp|jpe?g|png)(?:\?|$)/i;
    for (var i = 0; i < (images || []).length; i++) {
      var m = String(images[i]).match(re);
      if (m) return { set: m[1], num: m[2] };
    }
    return null;
  }
  /* candidate ids for a set code + number (raw, 3-padded, and unpadded) */
  function idsFor(setCode, num) {
    var raw = String(num), out = [setCode + '-' + raw];
    var pad = raw.replace(/^0+/, ''); while (pad.length < 3) pad = '0' + pad;
    if (out.indexOf(setCode + '-' + pad) < 0) out.push(setCode + '-' + pad);
    var strip = raw.replace(/^0+/, '') || raw;
    if (out.indexOf(setCode + '-' + strip) < 0) out.push(setCode + '-' + strip);
    return out;
  }

  /* ---- promo cards ---------------------------------------------------------
     A promo carries its set in the COLLECTOR NUMBER, not in the title: the
     title says only "PROMO". titleParts looks for an "<n>/<total>" pair, a
     promo has none, so TP.num came back empty and steps 4 and 5 never ran.
     Every promo in the catalogue therefore resolved to nothing and rendered no
     card panel at all, on products whose data TCGdex does have.

     Set ids and their number formats verified against the API on 2026-09-05:
       SVP029    -> svp-029          MEP046     -> mep-046      (bare, padded)
       SWSH071   -> swshp-SWSH071    SM01       -> smp-SM01     (prefix kept)
       XY01      -> xyp-XY01         BW01       -> bwp-BW01
       241/SV-P  -> SV-P-241         148/SV-P   -> SV-P-148     (Japanese)
     idsFor() then tries the raw, zero-padded and stripped forms, so the two
     padding conventions need no special handling here.

     Kept language-separated on purpose. Feeding a Japanese promo to an English
     set id, or the reverse, is the cross-language match that put wrong cards on
     pages before. ---- */
  function promoRef(t) {
    var tail = String(t || '').split(/\s[-–—]\s/).pop().trim();
    if (!tail) return null;
    var m;
    if (cfg.lang === 'en') {
      if ((m = tail.match(/^SVP\s*0*(\d{1,3})$/i)))  return { set: 'svp',   num: m[1] };
      if ((m = tail.match(/^MEP\s*0*(\d{1,3})$/i)))  return { set: 'mep',   num: m[1] };
      if ((m = tail.match(/^SWSH\s*(\d{1,3})$/i)))   return { set: 'swshp', num: 'SWSH' + m[1] };
      if ((m = tail.match(/^SM\s*(\d{1,3})$/i)))     return { set: 'smp',   num: 'SM' + m[1] };
      if ((m = tail.match(/^XY\s*(\d{1,3})$/i)))     return { set: 'xyp',   num: 'XY' + m[1] };
      if ((m = tail.match(/^BW\s*(\d{1,3})$/i)))     return { set: 'bwp',   num: 'BW' + m[1] };
      return null;
    }
    if (cfg.lang === 'ja') {
      if ((m = tail.match(/^0*(\d{1,3})\s*\/\s*SV\s*-?\s*P$/i))) return { set: 'SV-P', num: m[1] };
      if ((m = tail.match(/^0*(\d{1,3})\s*\/\s*M\s*-?\s*P$/i)))  return { set: 'M-P',  num: m[1] };
    }
    return null;
  }

  /* ---- gallery subsets -----------------------------------------------------
     Trainer Gallery and Galarian Gallery cards are numbered TG16/TG30 and
     GG01/GG70. titleParts looks for a leading digit, finds none, and the card
     resolved to nothing, so "Zeraora V : SILVER TEMPEST - TG16/TG30" showed no
     panel at all.

     They live in their own TCGdex set: the base set id with the gallery suffix
     appended. Verified 2026-09-05:
       swsh12tg-TG01     Silver Tempest Trainer Gallery
       swsh12.5gg-GG01   Crown Zenith Galarian Gallery
     The base id still comes from the set NAME in the title, so this only adds
     the suffix and the number. ---- */
  function galleryRef(t) {
    var tail = String(t || '').split(/\s[-–—]\s/).pop().trim();
    var m = tail.match(/^((TG|GG)\s*\d{1,3})\s*\/\s*(?:TG|GG)?\s*\d{1,3}$/i);
    if (!m) return null;
    return { num: m[1].replace(/\s+/g, '').toUpperCase(), suffix: m[2].toLowerCase() };
  }

  /* ---- title -> {name, setName, number, total}. Titles here read
     "<Name> : <SET NAME> (mods) - <num>/<total>". ---- */
  function titleParts(t) {
    t = String(t || '');
    var setName = '', num = '', total = '';
    var mn = t.match(/(\d{1,3}[A-Za-z]?)\s*\/\s*(\d{1,3})/);
    if (mn) { num = mn[1]; total = mn[2]; }
    var name = t.split(/\s[:：]\s/)[0].trim();
    var seg = t.split(/\s[:：]\s/)[1];
    if (seg) {
      setName = seg.replace(/\s*[-–—]\s*[A-Za-z0-9/]+\s*$/, '').replace(/\([^)]*\)/g, '').replace(/\s+/g, ' ').trim();
    }
    return { name: name, setName: setName, num: num, total: total };
  }

  /* ---- set NAME (from the product title) -> TCGdex set id -------------------
     A collector number is only unique WITHIN a set: Golurk is 43 in Furious
     Fists and 043 in Black Bolt. Searching by name+number therefore returned
     whichever print the API happened to list first, which put Furious Fists
     data (and its set symbol) on a Black Bolt product. The title already names
     the set, so resolve that to a set id and look the card up directly.
     The set list is small and near-static, so it is fetched once per page and
     cached for a day. ---- */
  /* v2: the slim record now keeps each set's symbol, which v1 discarded. */
  var SETS_CK = 'll_tcg_sets_v2_' + (cfg.lang || 'en');
  var setsPromise = null;
  function normName(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function loadSets() {
    if (setsPromise) return setsPromise;
    try {
      var o = JSON.parse(localStorage.getItem(SETS_CK) || 'null');
      if (o && o.exp > Date.now() && Object.prototype.toString.call(o.sets) === '[object Array]') {
        setsPromise = Promise.resolve(o.sets);
        return setsPromise;
      }
    } catch (e) {}
    setsPromise = fetch(BASE + (cfg.lang || 'en') + '/sets')
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (arr) {
        var slim = (Object.prototype.toString.call(arr) === '[object Array]' ? arr : []).map(function (s) {
          var cc = s.cardCount || {};
          return { id: s.id, n: normName(s.name), o: cc.official || 0, t: cc.total || 0, sym: s.symbol || '' };
        });
        try { localStorage.setItem(SETS_CK, JSON.stringify({ exp: Date.now() + 864e5, sets: slim })); } catch (e) {}
        return slim;
      })
      .catch(function () { return []; });
    return setsPromise;
  }
  /* When several sets share a normalised name, the printed total (the "/086")
     picks the right one. */
  function setIdFromTitle(name, total) {
    var want = normName(name);
    if (!want) return Promise.resolve(null);
    return loadSets().then(function (sets) {
      var hits = sets.filter(function (s) { return s.n === want; });
      if (!hits.length) return null;
      var t = parseInt(total, 10);
      if (hits.length > 1 && t) {
        for (var i = 0; i < hits.length; i++) {
          if (hits[i].o === t || hits[i].t === t) return hits[i].id;
        }
      }
      return hits[0].id;
    });
  }
  /* A name+number search cannot see which set it landed in, so check the print
     against the total from the title before trusting it. Without this, a number
     that exists in an older set silently wins. */
  function okSet(res) {
    var t = parseInt(TP.total, 10);
    if (!res || !res.card || !t) return res;
    var cc = (res.card.set || {}).cardCount || {};
    return (cc.official === t || cc.total === t) ? res : null;
  }

  /* ---- reprint sets that number cards by their ORIGINAL print --------------
     The 30th Celebration Classic Collection reprints older cards and prints
     each with its original set's number and total: Sneasel is 25/111 (Neo
     Genesis), which is no number in the 30th Celebration's own 128. The titles
     still say "30TH CELEBRATION", so step 4 resolved the main set, "25" landed
     on Pikachu #025, and a Sneasel page showed Pikachu's attacks. TCGdex files
     the reprints in a separate set ("30th-c") indexed by its own running order
     (Sneasel is 007), so the printed number can never find them. They are found
     by NAME instead. A name shared by several entries (Pikachu, Darkrai &
     Cresselia LEGEND) is ambiguous and is left to custom.tcg_card_id rather
     than guessed. To cover a future set, add its tagged set name (see
     SET_BY_TAG) and its reprint set id here. ---- */
  var CLASSIC_BY_TAG = { '30th Celebration': '30th-c' };
  function nameKey(s) {
    s = String(s || '');
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '');
  }
  function classicByName(setId, name) {
    var want = nameKey(name);
    if (!want) return Promise.resolve(null);
    return fetch(BASE + 'en/sets/' + encodeURIComponent(setId))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (set) {
        var hits = ((set && set.cards) || []).filter(function (c) { return nameKey(c.name) === want; });
        return hits.length === 1 ? fetchCard(hits[0].id) : null;
      })
      .catch(function () { return null; });
  }
  /* The number to print beside the set. TCGdex's localId is normally the printed
     number and stays (zero-padded like the rest of the catalogue), but a reprint
     set indexes by its own running order, so pairing Sneasel's 007 with the
     title's 111 printed a number that exists on no card. When the title's total
     is not this set's and its number is a different one, the title's pair is
     used whole. */
  function printedNumber(c) {
    var cc = (c.set && c.set.cardCount) || {};
    var tt = parseInt(TP.total, 10), tn = parseInt(TP.num, 10);
    if (tt && tn && cc.official !== tt && cc.total !== tt && String(tn) !== String(parseInt(c.localId, 10))) {
      var n = String(TP.num);
      while (n.length < 3) n = '0' + n;
      return { num: n, total: TP.total };
    }
    return { num: c.localId || TP.num || '', total: TP.total || cc.official || cc.total || '' };
  }
  /* TCGdex sends the literal string "None" for a card it holds no rarity for
     (every card in the 30th Classic Collection), and it printed as a chip. */
  function rarityOf(c) {
    var r = String((c && c.rarity) || '').trim();
    return /^none$/i.test(r) ? '' : r;
  }

  /* ---- resolution strategy, most precise first; stops at first hit ---- */
  function chain(fns) {
    return fns.reduce(function (pr, fn) {
      return pr.then(function (res) { return res || fn(); });
    }, Promise.resolve(null));
  }
  var TP = titleParts(cfg.title || '');
  function resolveCard() {
    var attempts = [];
    /* 1. explicit metafield id */
    if (cfg.cardId) attempts.push(function () { return fetchCard(cfg.cardId); });
    /* 2. set code + number from the product image filename */
    var code = codeFromImages(cfg.images);
    if (code) idsFor(code.set, code.num).forEach(function (id) { attempts.push(function () { return fetchCard(id); }); });
    /* 2b. promo set + number read off the printed code in the title. Exact, so
       it sits with the other exact methods rather than with the searches. */
    var promo = promoRef(cfg.title);
    if (promo) idsFor(promo.set, promo.num).forEach(function (id) { attempts.push(function () { return fetchCard(id); }); });
    /* 2c. gallery subset (TG / GG), which needs the base set from the title
       plus the gallery suffix. English printings only, like the other
       title-derived steps. */
    var gal = galleryRef(cfg.title);
    if (cfg.lang === 'en' && gal && TP.setName) {
      attempts.push(function () {
        return setIdFromTitle(TP.setName, null).then(function (sid) {
          if (!sid) return null;
          return chain(idsFor(sid + gal.suffix, gal.num).map(function (id) {
            return function () { return fetchCard(id); };
          }));
        });
      });
    }
    /* 3. metafield set id + number */
    if (cfg.setId && cfg.number) idsFor(cfg.setId, cfg.number).forEach(function (id) { attempts.push(function () { return fetchCard(id); }); });
    /* Steps 4 and 5 read the title, so both are ENGLISH-ONLY. A Japanese
       product's English title name must never be searched against a database
       (it can't match the JP names, and matching EN is exactly the
       cross-language mistake that produced wrong cards). JP resolves by the
       exact image / metafield code above, or it hides.

       4. set NAME + number from the title, resolved to a real set id. Ahead of
       the bare name search because it is exact: the set comes from the title
       rather than from whatever the API happens to list first. */
    if (cfg.lang === 'en' && TP.setName && TP.num) {
      attempts.push(function () {
        return setIdFromTitle(TP.setName, TP.total).then(function (sid) {
          if (!sid) return null;
          return chain(idsFor(sid, TP.num).map(function (id) {
            return function () { return fetchCard(id); };
          }));
        }).then(function (res) {
          /* A tagged set's titles do not always name the set the card was
             printed in (see CLASSIC_BY_TAG), so there the title's total has to
             match the set we landed in, or this hit is someone else's number. */
          return TAG_SET ? okSet(res) : res;
        });
      });
    }
    /* 4b. A reprint set's card, found by name, for tagged products that step 4
       rejected because their printed number belongs to the original print. */
    var classicId = CLASSIC_BY_TAG[TAG_SET];
    if (cfg.lang === 'en' && classicId && TP.name) {
      attempts.push(function () { return classicByName(classicId, TP.name); });
    }
    /* 5. Name + number, last resort — and only accepted if the set it landed in
       has the same card total as the title says. */
    if (cfg.lang === 'en' && TP.name && TP.num) {
      attempts.push(function () { return searchId('en', TP.name, TP.num).then(function (id) { return id ? fetchCard(id) : null; }).then(okSet); });
    }
    if (!attempts.length) return Promise.resolve(null);
    return chain(attempts);
  }

  /* ---- localStorage cache (keyed by product + query signature) ---- */
  /* v7: v6 cached MISSES for a day, and every promo and gallery card was a miss
     before the resolver learned about them. Without this bump the fix would
     have looked like it had not shipped for up to 24 hours per shopper, per
     product, which is exactly how it looked on the live Chikorita.

     The signature below covers the product's own data, not this file, so a
     change to the resolution logic does NOT invalidate anything on its own.
     Anything that makes a previously unmatched card matchable has to bump this
     number in the same commit. */
  var CK = 'll_tcg_v10_' + cfg.productId;   /* v10: Classic Collection cards resolve by name in their own set instead of taking the main set's card at the same number; v9: the image-code parser now tolerates Shopify's filename suffix, so ~132 Japanese products resolve that never did */
  var SIG = [cfg.cardId, cfg.setId, cfg.number, cfg.title, (cfg.images || []).join(','), (cfg.tags || []).join(','), cfg.lang, cfg.game, cfg.hideNonEnglish, cfg.translate, cfg.mmEmail, cfg.marketOn, cfg.ourPrice, cfg.currency].join('|');
  function cacheGet() {
    try {
      var o = JSON.parse(localStorage.getItem(CK));
      if (!o || o.sig !== SIG || Date.now() > o.exp) return undefined;
      return o.res; /* {card,lang} = hit, null = known miss */
    } catch (e) { return undefined; }
  }
  function cacheSet(res, hit) {
    try {
      var days = hit ? (cfg.cacheDays || 7) : 1;
      localStorage.setItem(CK, JSON.stringify({ sig: SIG, exp: Date.now() + days * 864e5, res: res }));
    } catch (e) {}
  }

  /* ---- TCGdex set-symbol image URL: from the embedded set.symbol (English
     cards), else constructed from the card image path; hidden on load error. ---- */
  /* TCGdex hands back a symbol path under /univ/, and that path 404s. Verified
     against the API on 2026-09-05: for xy10 it returns
     https://assets.tcgdex.net/univ/xy/xy10/symbol, and both .webp and .png of
     it are 404, while the same path under /en/ serves an 8.5 KB image. Same
     result for every English set tested.

     Because set.symbol is always present for English sets, this URL was always
     chosen and the Pokéllector fallback below it could never run, so EVERY
     Pokémon set symbol on the site was a broken image. It failed quietly: the
     panel has an onerror that hides the img, so the header simply rendered
     without a symbol and looked like a design choice.

     The asset host is language-scoped, so the URL is rewritten to the language
     the card was actually read from. */
  function symbolAsset(u, lang) {
    if (!u) return '';
    return String(u).replace('/univ/', '/' + (lang || 'en') + '/') + '.webp';
  }

  /* TCGdex is not consistent about the extension either. xy10's symbol serves
     as .webp and 404s as .png; swsh4's is exactly the other way round. Both
     checked on 2026-09-05. So .webp is tried first and .png once after it,
     before the image gives up and hides itself. Two possible requests for a
     3 KB image, only on the miss, and the browser caches the outcome. */
  function symFallback(img) {
    if (!img) return;
    img.onerror = function () {
      var s = this.getAttribute('src') || '';
      if (/\.webp$/i.test(s)) { this.setAttribute('src', s.replace(/\.webp$/i, '.png')); return; }
      /* Gallery subsets carry no symbol of their own: swsh12tg and swsh12.5gg
         both 404 in either extension, while their parents swsh12 and swsh12.5
         serve fine. That is not a workaround, it is what the cards show. A
         Trainer Gallery card is printed with the parent set's symbol, so
         Zeraora V TG16/TG30 should wear the Silver Tempest symbol.

         Falling back rather than resolving up front keeps the parent out of
         the way of any subset that does get its own symbol later. */
      var m = s.match(/^(.*\/)([^/]+?)(tg|gg)(\/symbol)\.png$/i);
      if (m) { this.setAttribute('src', m[1] + m[2] + m[4] + '.webp'); return; }
      this.style.display = 'none';
    };
  }

  function symbolUrl(c) {
    var set = c.set || {};
    if (set.symbol) return symbolAsset(set.symbol, cfg.lang);
    /* Built from the card image path, which carries the language as its first
       segment. That language is used rather than discarded for /univ/. */
    var m = String(c.image || '').match(/^(https?:\/\/[^/]+)\/([a-z]{2})\/([^/]+)\/([^/]+)\//i);
    return m ? 'https://assets.tcgdex.net/' + m[2] + '/' + m[3] + '/' + m[4] + '/symbol.webp' : '';
  }
  /* ---- pokemon.com Pokédex deep link for the species (from the English title). ---- */
  function pokedexLink() {
    if (!isPokemon(res0.card)) return '';
    var n = (TP.name || '').toLowerCase()
      .replace(/^.*'s\s+/, '')                                   /* "Team Rocket's Raticate" -> "Raticate" */
      .replace(/\b(ex|gx|vmax|vstar|v-?union|v|break|prime|star|tag\s*team|mega)\b/g, ' ')
      .replace(/['’.]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return n ? (cfg.pokedexBase || 'https://www.pokemon.com/uk/pokedex/') + n : '';
  }

  function stageLabel(stage) { return String(stage || '').replace(/^Stage\s?(\d)$/i, 'Stage $1'); }

  var res0 = null; /* current {card,lang,game} being rendered, for pokedexLink */

  /* ================= ONE PIECE (optcgapi.com — free, keyless, CORS, current) ==========
     One Piece products carry an exact code (OP16-022 / EB01-001 / ST01-001 / PRB01-001)
     in the image filename and title. optcgapi keeps the latest sets (OP-16, EB-03,
     PRB-02 ...), unlike the static datasets. We fetch that set (cached) and match the
     card_set_id exactly. Its cards also carry a market_price. */
  var OP_COLORS = { red: '#d23b2f', green: '#1f9d57', blue: '#2f74d0', purple: '#8b5cf6', black: '#3b3b46', yellow: '#e3b100' };
  function opColor(name) { return OP_COLORS[String(name || '').trim().toLowerCase()] || '#8a8a94'; }
  function titleCase(s) { return String(s || '').toLowerCase().replace(/\b\w/g, function (m) { return m.toUpperCase(); }); }
  var OP_RARITY = { l: 'Leader', c: 'Common', uc: 'Uncommon', r: 'Rare', sr: 'Super Rare', sec: 'Secret Rare', p: 'Promo', sp: 'Special', tr: 'Treasure' };
  /* "OP16-022" -> { setId:"OP-16", code:"OP16-022" } (optcgapi set ids are dashed). */
  function opCodeFrom(str) {
    var m = String(str || '').match(/\b([A-Za-z]{2,4})(\d{2})-(\d{2,3})\b/);
    return m ? { setId: (m[1] + '-' + m[2]).toUpperCase(), code: (m[1] + m[2] + '-' + m[3]).toUpperCase() } : null;
  }
  function resolveOnePiece() {
    var code = null, i;
    for (i = 0; i < (cfg.images || []).length && !code; i++) code = opCodeFrom(cfg.images[i]);
    if (!code) code = opCodeFrom(cfg.title);
    if (!code) return Promise.resolve(null);
    return fetch('https://optcgapi.com/api/sets/' + encodeURIComponent(code.setId) + '/')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (arr) {
        if (!Array.isArray(arr)) return null;
        /* A code is NOT unique here. 27 of the 155 rows in OP-16 share theirs,
           the base print and its parallel art carrying the same code and the
           same rarity but very different prices: OP16-021 appears twice as "R",
           at $18.04 and $0.48. Nothing in the row says which print it is, so
           the two cannot be told apart.

           The lowest price is taken deliberately. Card text, colour and stats
           are identical between the rows, so the only thing this choice
           affects is the market comparison, and picking the low row means the
           saving can only ever be understated. Claiming a shopper saved £13 on
           a 25p common, off a row we cannot verify, is the failure mode worth
           avoiding. */
        var hits = arr.filter(function (r) {
          return String(r.card_set_id || '').toUpperCase() === code.code;
        });
        if (!hits.length) return null;
        hits.sort(function (a, b) {
          var pa = parseFloat(a.market_price), pb = parseFloat(b.market_price);
          if (!(pa > 0)) return 1;
          if (!(pb > 0)) return -1;
          return pa - pb;
        });
        return { card: hits[0], game: 'onepiece' };
      }).catch(function () { return null; });
  }
  function renderOnePiece(res) {
    res0 = res;
    var c = res.card, setName = c.set_name || TP.setName || '';
    var colors = String(c.card_color || '').split(/[\/\s]+/).filter(Boolean);
    var h = '<div class="ll-tcg__eyebrow"><h2>Card details</h2><span class="ll-tcg__game">One Piece Card Game</span></div>';
    h += '<div class="ll-tcg__hd">';
    if (colors.length) h += '<span class="ll-op__colors">' + colors.map(function (cl) { return '<span class="ll-op__dot" style="background:' + opColor(cl) + '"></span>'; }).join('') + '</span>';
    h += '<div class="ll-tcg__setwrap"><div class="ll-tcg__set">' + esc(setName) + '</div><div class="ll-tcg__series">' + esc(c.card_set_id || '') + '</div></div>';
    if (c.rarity) h += '<span class="ll-tcg__rarity">' + esc(OP_RARITY[String(c.rarity).toLowerCase()] || c.rarity) + '</span>';
    h += '</div><div class="ll-tcg__body"><div class="ll-tcg__top">';
    h += '<span class="ll-tcg__cardtype">' + esc(titleCase(c.card_type)) + '</span>';
    if (c.sub_types) h += '<span class="ll-tcg__evo">' + esc(c.sub_types) + '</span>';
    var stats = [];
    if (c.card_type !== 'Leader' && c.card_cost != null && c.card_cost !== '') stats.push('Cost ' + esc(String(c.card_cost)));
    if (c.life != null && c.life !== '') stats.push('Life ' + esc(String(c.life)));
    if (c.card_power != null && c.card_power !== '') stats.push('Power ' + esc(String(c.card_power)));
    if (c.counter_amount) stats.push('Counter ' + esc(String(c.counter_amount)));
    if (c.attribute) stats.push(esc(c.attribute));
    if (stats.length) h += '<span class="ll-tcg__hp">' + stats.join('  ·  ') + '</span>';
    h += '</div>';
    if (c.card_text) h += '<div class="ll-tcg__abil"><div class="ll-tcg__abil-hd"><span class="ll-tcg__abil-tag">Effect</span></div><p>' + esc(c.card_text) + '</p></div>';
    h += '</div>';
    var ft = '<div class="ll-tcg__ft">';
    if (c.card_color) ft += '<span>Colour <strong>' + esc(c.card_color) + '</strong></span>';
    ft += '<span>' + esc(c.card_set_id || '') + (setName ? ' · ' + esc(setName) : '') + '</span>';
    ft += '<span class="ll-tcg__src">Card data via optcgapi.com (One Piece Card Game).</span></div>';
    return h + ft;
  }

  /* ================= SHARED: MAGIC + LORCANA ==================
     Neither game needs the tcg_set_id / card_number metafields. Both resolve from
     data the product already carries:
       • card name + collector number  -> the product title
       • set name                      -> the product tags
     The set has to come from the tags because it is not reliably in the title:
     Lorcana titles read "<Name> : <Version> - <num>/<total>", where the middle
     segment is the card's version ("Abu : Mischievous Monkey"), NOT the set; and
     the Magic set names in titles are the marketing ones, which do not match the
     databases ("DUNGEONS & DRAGONS: BATTLE FOR BALDUR'S GATE" is "Commander
     Legends: Battle for Baldur's Gate" to Scryfall). Rather than guess which tag
     is the set, we intersect the whole tag list against real set names. */
  var TAGS = cfg.tags || [];
  /* Catalogue-wide tags that are never a set name. */
  var SKIP_TAG = /^(single cards?|sealed product|foil|holographic|holo|alt art|art cards?|reverse holo|pre-?order|japanese|english|accessor(y|ies)|graded|sale|new|new arrivals?|magic the gathering|mtg|disney lorcana|lorcana|disney|pokemon|pokémon|one piece|digimon|plush)$/i;
  function setTags() {
    return TAGS.filter(function (t) { return t && !SKIP_TAG.test(String(t).trim()); });
  }
  /* "Abu (Foil)" -> "Abu"; also drops a trailing "- 128/204" for titles with no
     version segment ("A Pirate's Life - 128/204"). */
  function cleanName(n) {
    return String(n || '')
      .replace(/\([^)]*\)/g, ' ')
      .replace(/\s*[-–—]\s*\d{1,4}\s*\/\s*\d{1,4}\s*$/, '')
      .replace(/\s+/g, ' ').trim();
  }
  /* Collector numbers compare loosely on padding only: "087" == "87", but never
     "87" == "87a" (those are genuinely different printings). */
  function numEq(a, b) {
    a = String(a == null ? '' : a).trim(); b = String(b == null ? '' : b).trim();
    if (!a || !b) return false;
    if (a.toLowerCase() === b.toLowerCase()) return true;
    return a.replace(/^0+/, '') === b.replace(/^0+/, '');
  }
  /* Rules text keeps its line structure: Scryfall breaks lines with newlines,
     Lorcast separates paragraphs with a literal "%". */
  function multiline(s) { return esc(s).replace(/\r?\n/g, '<br>'); }
  function lorcText(s) { return multiline(String(s == null ? '' : s).replace(/\s*%\s*/g, '\n')); }
  /* Does any set tag look like this set name? Handles the marketing-prefix case
     ("Battle for Baldur's Gate" inside "Commander Legends: Battle for Baldur's
     Gate") in both directions. */
  function tagMatchesSet(setName) {
    var sn = slugify(setName), tags = setTags();
    if (!sn) return false;
    for (var i = 0; i < tags.length; i++) {
      var t = slugify(tags[i]);
      if (t && (t === sn || sn.indexOf(t) >= 0 || t.indexOf(sn) >= 0)) return true;
    }
    return false;
  }

  /* ================= DISNEY LORCANA (api.lorcast.com — free, keyless, CORS) =========
     Exact resolution: the set-name tag maps to a Lorcast set code via its /sets
     list (20 entries, cached for a week), and the collector number comes from the
     title, giving a direct /cards/<set>/<number> hit. Name + version search is the
     fallback for products with no recognised set tag. Lorcana has no set symbol
     art anywhere, so the ink colour stands in for a logo. */
  var LORC = 'https://api.lorcast.com/v0/';
  var INK_COLORS = { amber: '#e0a02c', amethyst: '#8b5cf6', emerald: '#1f9d57', ruby: '#d23b2f', sapphire: '#2f74d0', steel: '#8f9ea9' };
  function inkColor(n) { return INK_COLORS[String(n || '').trim().toLowerCase()] || '#8a8a94'; }
  function cardInks(c) { return (c.inks && c.inks.length) ? c.inks : (c.ink ? [c.ink] : []); }
  function inkDots(c, cls) {
    var inks = cardInks(c);
    if (!inks.length) return '';
    return inks.map(function (k) {
      return '<span class="' + cls + '" style="background:' + inkColor(k) + '" title="' + esc(k) + '"></span>';
    }).join('');
  }
  function lorcanaSets() {
    var ck = 'll_lorcana_sets_v1';
    try { var o = JSON.parse(localStorage.getItem(ck)); if (o && Date.now() < o.exp && o.sets) return Promise.resolve(o.sets); } catch (e) {}
    return fetch(LORC + 'sets').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var sets = (j && j.results) || [];
      try { localStorage.setItem(ck, JSON.stringify({ exp: Date.now() + 7 * 864e5, sets: sets })); } catch (e) {}
      return sets;
    }).catch(function () { return []; });
  }
  function lorcanaSetCode(sets) {
    var tags = setTags();
    for (var i = 0; i < sets.length; i++) {
      var sl = slugify(sets[i].name);
      for (var j = 0; j < tags.length; j++) if (slugify(tags[j]) === sl) return sets[i].code;
    }
    return '';
  }
  function resolveLorcana() {
    var name = cleanName(TP.name), num = TP.num;
    /* TP.setName holds the VERSION for Lorcana titles, not a set — see above. */
    var version = TP.setName || '';
    return lorcanaSets().then(function (sets) {
      var code = lorcanaSetCode(sets);
      if (!code || !num) return null;
      var n = String(num).replace(/^0+/, '') || String(num);
      return fetch(LORC + 'cards/' + encodeURIComponent(code) + '/' + encodeURIComponent(n))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { return (c && c.id) ? { card: c, game: 'lorcana' } : null; })
        .catch(function () { return null; });
    }).then(function (res) {
      if (res || !name) return res;
      return fetch(LORC + 'cards/search?q=' + encodeURIComponent('name:"' + name.replace(/"/g, '') + '"'))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var arr = (j && j.results) || [], want = slugify(version), pick = null, i;
          /* number + version, then version, then number — never a blind first hit,
             since Lorcana reprints the same name + version across sets. */
          for (i = 0; i < arr.length && !pick; i++) if (num && numEq(arr[i].collector_number, num) && want && slugify(arr[i].version) === want) pick = arr[i];
          for (i = 0; i < arr.length && !pick; i++) if (want && slugify(arr[i].version) === want && !num) pick = arr[i];
          for (i = 0; i < arr.length && !pick; i++) if (num && numEq(arr[i].collector_number, num)) pick = arr[i];
          return pick ? { card: pick, game: 'lorcana' } : null;
        }).catch(function () { return null; });
    }).catch(function () { return null; });
  }
  function renderLorcana(res) {
    res0 = res;
    var c = res.card, set = c.set || {}, dash = '<span class="ll-tcg__dash">—</span>';
    var types = (c.type || []).join(' · ');
    var h = '<div class="ll-tcg__eyebrow"><h2>Card details</h2><span class="ll-tcg__game">Disney Lorcana</span></div>';
    h += '<div class="ll-tcg__hd">';
    var dots = inkDots(c, 'll-op__dot');
    if (dots) h += '<span class="ll-op__colors">' + dots + '</span>';
    h += '<div class="ll-tcg__setwrap"><div class="ll-tcg__set">' + esc(set.name || '') + '</div>' +
      '<div class="ll-tcg__series">' + esc(cardInks(c).join(' / ')) + (c.collector_number ? ' · ' + esc(c.collector_number) : '') + '</div></div>';
    if (c.rarity) h += '<span class="ll-tcg__rarity">' + esc(c.rarity) + '</span>';
    h += '</div><div class="ll-tcg__body"><div class="ll-tcg__top">';
    if (types) h += '<span class="ll-tcg__cardtype">' + esc(types) + '</span>';
    if ((c.classifications || []).length) h += '<span class="ll-tcg__evo">' + esc(c.classifications.join(' · ')) + '</span>';
    var stats = [];
    if (c.cost != null && c.cost !== '') stats.push('Cost ' + esc(String(c.cost)));
    if (c.move_cost != null && c.move_cost !== '') stats.push('Move ' + esc(String(c.move_cost)));
    if (stats.length) h += '<span class="ll-tcg__hp">' + stats.join('  ·  ') + '</span>';
    h += '</div>';
    if ((c.keywords || []).length) {
      h += '<div class="ll-tcg__abil"><div class="ll-tcg__abil-hd"><span class="ll-tcg__abil-tag">Keywords</span>' +
        '<span class="ll-tcg__abil-name">' + esc(c.keywords.join(', ')) + '</span></div></div>';
    }
    if (c.text || c.flavor_text) {
      h += '<div class="ll-tcg__atks"><div class="ll-tcg__atk">';
      if (c.text) h += '<p class="ll-tcg__atk-txt">' + lorcText(c.text) + '</p>';
      if (c.flavor_text) h += '<p class="ll-tcg__atk-txt" style="font-style:italic;opacity:.72">' + multiline(c.flavor_text) + '</p>';
      h += '</div></div>';
    }
    if (c.strength != null || c.willpower != null || c.lore != null) {
      h += '<div class="ll-tcg__wrr">' +
        '<div><span class="k">Strength</span><span class="v">' + (c.strength != null ? esc(String(c.strength)) : dash) + '</span></div>' +
        '<div><span class="k">Willpower</span><span class="v">' + (c.willpower != null ? esc(String(c.willpower)) : dash) + '</span></div>' +
        '<div><span class="k">Lore</span><span class="v">' + (c.lore != null ? esc(String(c.lore)) : dash) + '</span></div></div>';
    }
    h += '</div>';
    var ft = '<div class="ll-tcg__ft">';
    if ((c.illustrators || []).length) ft += '<span>Illustrator <strong>' + esc(c.illustrators.join(', ')) + '</strong></span>';
    ft += '<span>' + esc(set.name || '') + (c.collector_number ? ' · ' + esc(c.collector_number) : '') + '</span>';
    if (typeof c.inkwell === 'boolean') ft += '<span>Inkwell <strong>' + (c.inkwell ? 'Yes' : 'No') + '</strong></span>';
    ft += '<span class="ll-tcg__src">Card data via Lorcast.</span></div>';
    return h + ft;
  }

  /* ================= MAGIC: THE GATHERING (api.scryfall.com — free, keyless, CORS) ===
     One exact-name search returns every printing; the collector number from the
     title picks the right one and the set tag breaks any tie. That ordering matters
     because the store's printed set names don't match Scryfall's. Art cards live in
     a separate art-series set that default search excludes, so they get their own
     query. Set symbols are SVGs from svgs.scryfall.io, crisp at any size. */
  var SCRY = 'https://api.scryfall.com/';
  var MTG_RARITY = { common: 'Common', uncommon: 'Uncommon', rare: 'Rare', mythic: 'Mythic Rare', special: 'Special', bonus: 'Bonus' };
  var MANA_COLORS = { W: ['#f6f0dc', '#4a4433'], U: ['#3f8bd4', '#fff'], B: ['#4c4553', '#fff'], R: ['#d8503a', '#fff'], G: ['#3f9e5f', '#fff'], C: ['#cfc9c0', '#4a4433'] };
  function mtgSymbolUrl(code) {
    return code ? 'https://svgs.scryfall.io/sets/' + encodeURIComponent(String(code).toLowerCase()) + '.svg' : '';
  }
  /* "{2}{U}{U}" -> three pips. Hybrid / Phyrexian symbols keep their letters and
     fall back to the generic disc. */
  function manaPips(cost) {
    var out = '', re = /\{([^}]+)\}/g, m;
    while ((m = re.exec(String(cost || '')))) {
      var sym = m[1].toUpperCase(), col = MANA_COLORS[sym];
      out += '<span class="ll-mtg__pip" style="background:' + (col ? col[0] : '#cfc9c0') + ';color:' + (col ? col[1] : '#4a4433') + '">' +
        esc(sym.replace(/\//g, '')) + '</span>';
    }
    return out;
  }
  function resolveMagic() {
    var name = cleanName(TP.name);
    if (!name) return Promise.resolve(null);
    var isArt = /\bart\s*card\b/i.test(cfg.title || '') || /art card/i.test(TAGS.join(','));
    var q = '!"' + name.replace(/["\\]/g, '') + '"' + (isArt ? ' is:art_series' : '');
    var url = SCRY + 'cards/search?unique=prints&q=' + encodeURIComponent(q) +
      (cfg.lang !== 'en' ? '&include_multilingual=true' : '');
    return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var arr = (j && j.data) || [], num = TP.num, pick = null, i;
      if (!arr.length) return null;
      for (i = 0; i < arr.length && !pick; i++) if (num && numEq(arr[i].collector_number, num) && tagMatchesSet(arr[i].set_name)) pick = arr[i];
      for (i = 0; i < arr.length && !pick; i++) if (num && numEq(arr[i].collector_number, num)) pick = arr[i];
      for (i = 0; i < arr.length && !pick; i++) if (tagMatchesSet(arr[i].set_name)) pick = arr[i];
      /* With a number in the title and nothing matching it, hiding beats showing a
         different printing — same rule the Pokémon resolver follows. */
      if (!pick && !num) pick = arr[0];
      return pick ? { card: pick, game: 'mtg' } : null;
    }).catch(function () { return null; });
  }
  function renderMagic(res) {
    res0 = res;
    var c = res.card, dash = '<span class="ll-tcg__dash">—</span>';
    var faces = (c.card_faces && c.card_faces.length) ? c.card_faces : [c];
    var sym = mtgSymbolUrl(c.set);
    var h = '<div class="ll-tcg__eyebrow"><h2>Card details</h2><span class="ll-tcg__game">Magic: The Gathering</span></div>';
    h += '<div class="ll-tcg__hd">';
    if (sym) h += '<img class="ll-tcg__sym ll-tcg__sym--mtg" src="' + esc(sym) + '" alt="" loading="lazy" width="34" height="34">';
    h += '<div class="ll-tcg__setwrap"><div class="ll-tcg__set">' + esc(c.set_name || '') + '</div>' +
      '<div class="ll-tcg__series">' + esc(String(c.set || '').toUpperCase()) + (c.collector_number ? ' · ' + esc(c.collector_number) : '') + '</div></div>';
    if (c.rarity) h += '<span class="ll-tcg__rarity">' + esc(MTG_RARITY[c.rarity] || titleCase(c.rarity)) + '</span>';
    h += '</div><div class="ll-tcg__body">';
    /* Art-series cards carry no gameplay data (Scryfall fills type_line with
       "Card" and leaves the cost empty), so they get the artwork facts only. */
    if (c.layout === 'art_series' || c.set_type === 'memorabilia') {
      h += '<div class="ll-tcg__top"><span class="ll-tcg__cardtype">Art series card</span>' +
        (c.artist ? '<span class="ll-tcg__evo">Art by ' + esc(c.artist) + '</span>' : '') + '</div></div>';
      var aft = '<div class="ll-tcg__ft">';
      aft += '<span>' + esc(c.set_name || '') + (c.collector_number ? ' · ' + esc(c.collector_number) : '') + '</span>';
      if (c.scryfall_uri) aft += '<a href="' + esc(c.scryfall_uri) + '" target="_blank" rel="noopener">Scryfall ↗</a>';
      aft += '<span class="ll-tcg__src">Card data and set symbol via Scryfall.</span></div>';
      return h + aft;
    }
    faces.forEach(function (f) {
      h += '<div class="ll-tcg__top">';
      if (f.type_line) h += '<span class="ll-tcg__cardtype">' + esc(f.type_line) + '</span>';
      var pips = manaPips(f.mana_cost);
      if (pips) h += '<span class="ll-tcg__hp"><span class="ll-tcg__types">' + pips + '</span></span>';
      h += '</div>';
      if (f.oracle_text) h += '<div class="ll-tcg__atks"><div class="ll-tcg__atk"><p class="ll-tcg__atk-txt">' + multiline(f.oracle_text) + '</p></div></div>';
    });
    var st = null, i;
    for (i = 0; i < faces.length && !st; i++) if (faces[i].power != null || faces[i].loyalty != null) st = faces[i];
    var mv = (c.cmc == null) ? '' : String(c.cmc).replace(/\.0$/, '');
    var cells;
    if (st && st.power != null) {
      cells = [['Power', esc(String(st.power))], ['Toughness', st.toughness != null ? esc(String(st.toughness)) : dash], ['Mana value', mv ? esc(mv) : dash]];
    } else if (st && st.loyalty != null) {
      cells = [['Loyalty', esc(String(st.loyalty))], ['Mana value', mv ? esc(mv) : dash], ['Rarity', esc(MTG_RARITY[c.rarity] || titleCase(c.rarity || ''))]];
    } else {
      var ci = (c.color_identity || []).map(function (x) { return '{' + x + '}'; }).join('');
      cells = [['Mana value', mv ? esc(mv) : dash], ['Colours', ci ? manaPips(ci) : 'Colourless'], ['Set', esc(String(c.set || '').toUpperCase())]];
    }
    h += '<div class="ll-tcg__wrr">' + cells.map(function (cell) {
      return '<div><span class="k">' + cell[0] + '</span><span class="v">' + cell[1] + '</span></div>';
    }).join('') + '</div>';
    h += '</div>';
    var ft = '<div class="ll-tcg__ft">';
    if (c.artist) ft += '<span>Illustrator <strong>' + esc(c.artist) + '</strong></span>';
    ft += '<span>' + esc(c.set_name || '') + (c.collector_number ? ' · ' + esc(c.collector_number) : '') + '</span>';
    var LEG = [['standard', 'Standard'], ['pioneer', 'Pioneer'], ['modern', 'Modern'], ['commander', 'Commander']];
    var legal = c.legalities || {};
    var legalIn = LEG.filter(function (l) { return legal[l[0]] === 'legal'; }).map(function (l) { return l[1]; });
    if (legalIn.length) ft += '<span>Legal in <strong>' + esc(legalIn.join(', ')) + '</strong></span>';
    if (c.scryfall_uri) ft += '<a href="' + esc(c.scryfall_uri) + '" target="_blank" rel="noopener">Scryfall ↗</a>';
    ft += '<span class="ll-tcg__src">Card data and set symbol via Scryfall.</span></div>';
    return h + ft;
  }

  /* ================= MARKET-PRICE TREND (single Pokémon cards only) ==================
     Uses the card's Cardmarket avg30 / avg7 / avg1 (EUR) as a trend, converts to the
     shop currency, and ONLY renders when our price beats the current market average. */
  var CURSYM = { GBP: '£', USD: '$', EUR: '€', CAD: 'CA$', AUD: 'A$' };
  function money(n) { return (CURSYM[cfg.currency] || (cfg.currency + ' ')) + n.toFixed(2); }
  function cardmarketPrices(card) {
    var cm = card.pricing && card.pricing.cardmarket;
    if (!cm && card.variants_detailed) {
      for (var i = 0; i < card.variants_detailed.length; i++) {
        var p = card.variants_detailed[i].pricing;
        if (p && p.cardmarket) { cm = p.cardmarket; break; }
      }
    }
    if (!cm) return null;
    /* Cardmarket publishes a parallel set of holo figures, and they are not
       close: on the card checked while writing this, avg was 0.09 and avg-holo
       0.33. Quoting the plain average against a holo product would overstate
       the saving, which is the one mistake a price panel must not make. */
    var h = isFoilProduct() && typeof cm['avg-holo'] === 'number';
    var pick = function (k) { return h && typeof cm[k + '-holo'] === 'number' ? cm[k + '-holo'] : cm[k]; };
    return {
      avg: pick('avg'), avg1: pick('avg1'), avg7: pick('avg7'), avg30: pick('avg30'),
      trend: pick('trend'), low: cm.low, updated: cm.updated, holo: h
    };
  }

  /* Foil, holo and reverse holo all carry their own market price. The product
     title is the only place this shop states it. "Non-foil" is excluded so the
     word inside it cannot flip the test. */
  function isFoilProduct() {
    var t = String(cfg.title || '');
    if (/non[-\s]?foil/i.test(t)) return false;
    return /\b(foil|holo|holofoil|reverse)\b/i.test(t);
  }

  /* ---- market price, normalised across the four games -----------------------
     Every game publishes a price, they just publish different shapes, so each
     is reduced to the same record and the panel below never asks which game it
     is drawing. Only Pokémon carries history, so `series` is the one field that
     is often absent, and the panel degrades to the comparison bars.

     Verified on the live APIs 2026-09-06. ---- */
  function marketPrice(res) {
    var c = (res && res.card) || {}, foil = isFoilProduct(), v;

    if (res.game === 'pokemon') {
      var pr = cardmarketPrices(c);
      if (!pr) return null;
      var now = pr.trend || pr.avg || pr.avg1;
      if (!(now > 0)) return null;
      var series = [pr.avg30, pr.avg7, pr.avg1, pr.trend || pr.avg]
        .filter(function (n) { return typeof n === 'number' && n > 0; });
      return {
        unit: 'EUR', now: now, low: pr.low > 0 ? pr.low : null,
        series: series.length > 1 ? series : null,
        source: 'Cardmarket', window: '30-day', updated: pr.updated,
        variant: pr.holo ? 'holo' : null
      };
    }

    if (res.game === 'mtg') {
      /* Scryfall's eur is Cardmarket and usd is TCGplayer. EUR is preferred
         because this is a UK shop buying into a European market. */
      var p = c.prices || {};
      v = parseFloat(foil ? p.eur_foil : p.eur);
      if (v > 0) return { unit: 'EUR', now: v, source: 'Cardmarket', variant: foil ? 'foil' : null };
      v = parseFloat(foil ? p.usd_foil : p.usd);
      if (v > 0) return { unit: 'USD', now: v, source: 'TCGplayer', variant: foil ? 'foil' : null };
      return null;
    }

    if (res.game === 'lorcana') {
      var lp = c.prices || {};
      v = parseFloat(foil ? lp.usd_foil : lp.usd);
      if (!(v > 0)) v = parseFloat(lp.usd);
      return v > 0 ? { unit: 'USD', now: v, source: 'TCGplayer', variant: foil ? 'foil' : null } : null;
    }

    if (res.game === 'onepiece') {
      v = parseFloat(c.market_price);
      /* No named marketplace: optcgapi does not say whose price it is, and
         naming one we cannot verify would be worse than staying vague. */
      return v > 0 ? { unit: 'USD', now: v, source: null } : null;
    }

    return null;
  }
  function fxRate(from, to) {
    if (!from || !to || from === to) return Promise.resolve(1);
    var ck = 'll_fx_' + from;
    try { var o = JSON.parse(localStorage.getItem(ck)); if (o && Date.now() < o.exp && o.rates && o.rates[to]) return Promise.resolve(o.rates[to]); } catch (e) {}
    return fetch('https://open.er-api.com/v6/latest/' + from).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.rates) return null;
      try { localStorage.setItem(ck, JSON.stringify({ exp: Date.now() + 864e5, rates: j.rates })); } catch (e) {}
      return j.rates[to] || null;
    }).catch(function () { return null; });
  }
  function sparkline(pts) {
    if (pts.length < 2) return '';
    var W = 300, H = 50, pad = 5, n = pts.length;
    var min = Math.min.apply(null, pts), max = Math.max.apply(null, pts), rng = (max - min) || 1;
    var d = pts.map(function (p, i) { var x = pad + (W - 2 * pad) * i / (n - 1); var y = pad + (H - 2 * pad) * (1 - (p - min) / rng); return (i ? 'L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1); }).join(' ');
    var area = d + ' L' + (W - pad) + ' ' + (H - pad) + ' L' + pad + ' ' + (H - pad) + ' Z';
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none" class="ll-mktg__spark" aria-hidden="true"><path d="' + area + '" fill="var(--ll-accent-bg,rgba(139,92,246,.16))"/><path d="' + d + '" fill="none" stroke="var(--ll-accent-2,#7c4ddb)" stroke-width="2" vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function renderMarket(res) {
    var box = root.querySelector('[data-mktg]');
    if (!box) return;
    var mp = marketPrice(res);
    if (!mp) return;

    fxRate(mp.unit, cfg.currency || 'GBP').then(function (rate) {
      if (!rate) return;
      var ourPrice = (cfg.ourPrice || 0) / 100;
      var marketNow = mp.now * rate;

      /* The rule the owner set, and the only reason this panel exists: it
         appears when we are cheaper, and says nothing at all when we are not.
         Never spin a worse price as a good one. */
      if (!(ourPrice > 0 && marketNow > 0) || ourPrice >= marketNow) return;

      var save = marketNow - ourPrice;
      var pct = Math.round(save / marketNow * 100);

      /* CREDIBILITY BOUNDS. Free market feeds carry bad rows, and this panel
         makes a claim to a customer, so it has to refuse the ones it cannot
         stand behind.

         Measured on One Piece OP-16, 2026-09-06: of 111 cards matched, we were
         cheaper on 15, and several of those "wins" were nonsense. A 15p common
         showed a £847 market price, another £47. Rendering "Save 100%" on those
         would be worse than showing nothing: it is not a bargain, it is a bad
         row, and a shopper who checks will stop believing the panel.

         Above 70% the reference is treated as untrustworthy and the panel stays
         silent. Below 3% there is no story worth telling and rounding noise in
         the exchange rate can flip the sign on its own. */
      if (pct < 3 || pct > 70) return;
      var low = mp.low > 0 ? mp.low * rate : null;
      var pts = mp.series ? mp.series.map(function (v) { return v * rate; }) : null;

      /* Bars are drawn relative to the market price, so ours is always the
         shorter one and the gap is the saving, read without doing the sum. */
      var ourPct = Math.max(4, Math.round(ourPrice / marketNow * 100));

      var facts = '';
      /* Direction of travel over the window, which tells a shopper whether
         this is a dip worth taking or a card on the way down. */
      if (pts && pts.length > 1) {
        var first = pts[0], last = pts[pts.length - 1];
        if (first > 0) {
          var move = Math.round((last - first) / first * 100);
          if (move >= 5) facts += '<span class="ll-mktg__fact">Market <strong>up ' + move + '%</strong> in 30 days</span>';
          else if (move <= -5) facts += '<span class="ll-mktg__fact">Market <strong>down ' + Math.abs(move) + '%</strong> in 30 days</span>';
          else facts += '<span class="ll-mktg__fact">Market <strong>steady</strong> over 30 days</span>';
        }
      }
      /* Beating the cheapest listing anywhere is a stronger claim than beating
         the average, so it is only made when it is actually true. */
      if (low && ourPrice < low) {
        facts += '<span class="ll-mktg__fact">Below the <strong>lowest listing</strong> (' + money(low) + ')</span>';
      }
      if (mp.variant) {
        facts += '<span class="ll-mktg__fact">Priced as <strong>' + esc(mp.variant) + '</strong></span>';
      }

      var head = mp.series ? 'Market price trend' : 'Market price check';

      var note = (mp.window ? mp.window + ' ' : '') + (mp.source ? mp.source + ' data' : 'Market data') +
        (mp.unit !== (cfg.currency || 'GBP') ? ', converted to ' + esc(cfg.currency || 'GBP') : '') +
        '. You pay ' + pct + '% below the current market' + (mp.series ? ' average' : '') + '.';

      box.innerHTML =
        '<div class="ll-mktg__hd"><span class="ll-mktg__ttl">' + head + '</span>' +
          '<span class="ll-mktg__save">Save ' + money(save) + (pct > 0 ? ' (' + pct + '%)' : '') + '</span></div>' +
        '<div class="ll-mktg__row">' +
          '<div class="ll-mktg__cell"><span class="k">Market</span><span class="v">' + money(marketNow) + '</span></div>' +
          '<div class="ll-mktg__cell ll-mktg__cell--ours"><span class="k">Our price</span><span class="v">' + money(ourPrice) + '</span></div>' +
        '</div>' +
        '<div class="ll-mktg__bars">' +
          '<div class="ll-mktg__bar"><span class="k">Market</span><span class="ll-mktg__track"><span class="ll-mktg__fill" data-w="100"></span></span><span class="amt">' + money(marketNow) + '</span></div>' +
          '<div class="ll-mktg__bar ll-mktg__bar--ours"><span class="k">Ours</span><span class="ll-mktg__track"><span class="ll-mktg__fill" data-w="' + ourPct + '"></span></span><span class="amt">' + money(ourPrice) + '</span></div>' +
        '</div>' +
        (pts ? '<div class="ll-mktg__chart">' + sparkline(pts) +
          '<div class="ll-mktg__axis"><span>30 days ago</span><span>Today</span></div></div>' : '') +
        (facts ? '<div class="ll-mktg__facts">' + facts + '</div>' : '') +
        '<p class="ll-mktg__note">' + note + '</p>';

      box.hidden = false;
      /* Widths are set after paint so the bars grow into place rather than
         appearing already full. One transition, no library. */
      requestAnimationFrame(function () {
        box.classList.add('is-in');
        var fills = box.querySelectorAll('.ll-mktg__fill');
        for (var i = 0; i < fills.length; i++) fills[i].style.width = fills[i].getAttribute('data-w') + '%';
      });
    }).catch(function () {});
  }

  /* ---- render ---- */
  function render(res) {
    if (res.game === 'onepiece') return renderOnePiece(res);
    if (res.game === 'lorcana') return renderLorcana(res);
    if (res.game === 'mtg') return renderMagic(res);
    res0 = res;
    var c = res.card, set = c.set || {};
    /* Prefer the English set name + number from the product title (keeps the
       header English even for Japanese cards); fall back to TCGdex. */
    var setName = preferredSetName(set.name);
    var pn = printedNumber(c), num = pn.num, total = pn.total;
    /* Set symbol, most authoritative first. TCGdex's own set.symbol belongs to
       the card we actually resolved, so it is always the right language and
       print. The Pokéllector map is keyed by English set NAME, and several
       Japanese sets share their English name with a separate English set
       (Black Bolt, White Flare, Pitch Black, Mega Evolution, Chaos Rising...),
       so consulting it first served the Japanese symbol on English cards.
       Pokéllector stays as the fallback it was written to be: TCGdex carries no
       set.symbol for Japanese sets. */
    var sym = TAG_SET ? pkSymbol(TAG_SET) : '';
    var pkUsed = !!sym;
    if (!sym) sym = symbolAsset(set.symbol, cfg.lang);
    if (!sym) { sym = pkSymbol(setName); pkUsed = !!sym; }
    if (!sym) sym = symbolUrl(c);
    var typesHtml = (c.types || []).map(energyIco).join('');
    var cat = isPokemon(c) ? 'Pokémon' : (c.category || '');
    var cardType = (stageLabel(c.stage) + ' ' + cat).replace(/\s+/g, ' ').trim();
    if (c.category === 'Trainer') cardType = ((c.trainerType ? c.trainerType + ' ' : '') + 'Trainer').trim();
    else if (c.category === 'Energy') cardType = ((c.energyType ? c.energyType + ' ' : '') + 'Energy').trim();

    var h = '<div class="ll-tcg__eyebrow"><h2>Card details</h2><span class="ll-tcg__game">Pokémon TCG</span></div>';
    h += '<div class="ll-tcg__hd">';
    if (sym) h += '<img class="ll-tcg__sym" src="' + esc(sym) + '" alt="" loading="lazy" width="52" height="38">';
    h += '<div class="ll-tcg__setwrap"><div class="ll-tcg__set">' + esc(setName) + '</div></div>';
    if (rarityOf(c)) h += '<span class="ll-tcg__rarity">' + esc(rarityOf(c)) + '</span>';
    h += '</div>';

    h += '<div class="ll-tcg__body">';
    h += '<div class="ll-tcg__top">';
    if (cardType) h += '<span class="ll-tcg__cardtype">' + esc(cardType) + '</span>';
    if (c.evolveFrom) h += '<span class="ll-tcg__evo">Evolves from ' + esc(c.evolveFrom) + '</span>';
    if (c.hp != null && c.hp !== '') h += '<span class="ll-tcg__hp">HP ' + esc(c.hp) + (typesHtml ? '<span class="ll-tcg__types">' + typesHtml + '</span>' : '') + '</span>';
    else if (typesHtml) h += '<span class="ll-tcg__hp"><span class="ll-tcg__types">' + typesHtml + '</span></span>';
    h += '</div>';

    (c.abilities || []).forEach(function (a) {
      h += '<div class="ll-tcg__abil"><div class="ll-tcg__abil-hd"><span class="ll-tcg__abil-tag">' + esc(a.type || 'Ability') +
        '</span><span class="ll-tcg__abil-name">' + esc(a.name) + '</span></div>' +
        (a.effect ? '<p>' + fxHtml(a.effect) + '</p>' : '') + '</div>';
    });

    if ((c.attacks || []).length) {
      h += '<div class="ll-tcg__atks">';
      c.attacks.forEach(function (a) {
        var costHtml = (a.cost && a.cost.length) ? a.cost.map(energyIco).join('') : '';
        var dmg = (a.damage != null && a.damage !== '') ? esc(String(a.damage)) : '';
        h += '<div class="ll-tcg__atk"><div class="ll-tcg__atk-hd"><span class="ll-tcg__cost">' + costHtml +
          '</span><span class="ll-tcg__atk-name">' + esc(a.name) + '</span>' +
          (dmg ? '<span class="ll-tcg__atk-dmg">' + dmg + '</span>' : '') + '</div>' +
          (a.effect ? '<p class="ll-tcg__atk-txt">' + fxHtml(a.effect) + '</p>' : '') + '</div>';
      });
      h += '</div>';
    } else if ((c.effect || (c.item && c.item.effect))) {
      h += '<div class="ll-tcg__atks"><div class="ll-tcg__atk"><p class="ll-tcg__atk-txt">' + fxHtml(c.effect || c.item.effect) + '</p></div></div>';
    }

    if (isPokemon(c)) {
      /* An absent field and an empty one mean different things. TCGdex omits
         weaknesses/resistances entirely for sets it has not filled in yet (the
         whole English Black Bolt set, for one), while an empty array is a real
         "this card has none". Printing an em dash for both told customers a
         card had no weakness when it has Fire x2 on the print. Absent -> drop
         the cell; empty -> dash, which is now truthful. */
      var dash = '<span class="ll-tcg__dash">—</span>';
      var hasWk = Array.isArray(c.weaknesses), hasRs = Array.isArray(c.resistances);
      var wk = hasWk ? c.weaknesses[0] : null, rs = hasRs ? c.resistances[0] : null;
      var wkH = wk ? energyIco(wk.type) + '<span>' + esc(wk.value || '') + '</span>' : dash;
      var rsH = rs ? energyIco(rs.type) + '<span>' + esc(rs.value || '') + '</span>' : dash;
      var rc = (typeof c.retreat === 'number') ? c.retreat : parseInt(c.retreat, 10);
      var hasRc = !isNaN(rc);
      var rcH = dash;
      if (rc > 0) { rcH = ''; for (var i = 0; i < rc; i++) rcH += energyIco('Colorless'); }
      var wrr = '';
      if (hasWk) wrr += '<div><span class="k">Weakness</span><span class="v">' + wkH + '</span></div>';
      if (hasRs) wrr += '<div><span class="k">Resistance</span><span class="v">' + rsH + '</span></div>';
      if (hasRc) wrr += '<div><span class="k">Retreat</span><span class="v">' + rcH + '</span></div>';
      if (wrr) h += '<div class="ll-tcg__wrr">' + wrr + '</div>';
    }
    h += '</div>'; /* /body */

    var ft = '<div class="ll-tcg__ft">';
    if (c.illustrator) ft += '<span>Illustrator <strong>' + esc(c.illustrator) + '</strong></span>';
    ft += '<span>' + esc(setName) + (num ? ' · ' + esc(num) + (total ? '/' + esc(String(total)) : '') : '') + '</span>';
    if (c.regulationMark) ft += '<span>Regulation <strong>' + esc(c.regulationMark) + '</strong></span>';
    var link = pokedexLink();
    if (link) ft += '<a href="' + esc(link) + '" target="_blank" rel="noopener">Pokédex ↗</a>';
    ft += '<span class="ll-tcg__src">' + (res.translated ? 'Ability / attack text auto-translated from Japanese. ' : '') +
      'Card data via TCGdex' + (pkUsed ? ', set symbol via Pokellector' : '') + '.</span>';
    ft += '</div>';

    return h + ft;
  }

  /* ---- card type -> theme key ----------------------------------------------
     Every game names its types differently, so each is reduced to one lowercase
     word that the CSS above understands. Pokémon energy types, Magic colours,
     One Piece colours and Lorcana inks all land in the same vocabulary, which
     is why a Fire Pokémon and a Red One Piece card theme identically.

     A card with more than one type themes as "multi" rather than picking one,
     because guessing a dominant colour on a two-colour card looks like a bug to
     anyone who plays the game. Returns '' when the game carries no type, and
     the panel then keeps its neutral chrome. */
  function typeKey(res) {
    var c = (res && res.card) || {};
    if (res.game === 'mtg') {
      var col = c.colors || [];
      if (!col.length) return 'colorless';
      if (col.length > 1) return 'multi';
      return ({ W: 'white', U: 'blue', B: 'black', R: 'red', G: 'green' })[col[0]] || '';
    }
    if (res.game === 'onepiece') {
      /* optcgapi writes a dual colour as "Blue Green", SPACE separated, not
         "Blue/Green" as first assumed. Monkey.D.Luffy OP16-022 came back as the
         literal string "blue green", which matched no rule and fell back to the
         neutral violet. Any separator at all, space included, means multi. */
      var oc = String(c.card_color || '').trim();
      if (!oc) return '';
      if (/[\s\/,;|]/.test(oc)) return 'multi';
      return oc.toLowerCase();
    }
    if (res.game === 'lorcana') {
      var inks = cardInks(c);
      if (!inks.length) return '';
      return inks.length > 1 ? 'multi' : String(inks[0]).trim().toLowerCase();
    }
    var t = (c.types || []);
    if (!t.length) return '';
    return t.length > 1 ? 'multi' : String(t[0]).trim().toLowerCase();
  }

  /* ---- last-resort set symbol, from the cached set LIST ---------------------
     Some cards carry neither a set.symbol nor a card image to build one from.
     The gallery subsets are the clean example: swsh12tg-TG16 has no image
     field and its set object is only {id, name, cardCount}, so all three of the
     usual sources came up empty and Zeraora V rendered with no symbol at all.

     The set list DOES carry symbols, and it is already fetched and cached for a
     day for the set-name lookup, so the answer is there for free. Gallery
     subsets have no symbol of their own in the list either, so the parent set
     is used, which is also what the card is printed with.

     Patched in after render rather than blocking it: the list may still be in
     flight, and a symbol arriving a moment later is better than a panel that
     waits for one. ---- */
  function patchSymbol(res, host, cls) {
    var setId = res && res.card && res.card.set && res.card.set.id;
    if (!host || !setId || host.querySelector('.' + cls)) return;
    loadSets().then(function (sets) {
      if (host.querySelector('.' + cls)) return;
      var want = String(setId).toLowerCase();
      var parent = want.replace(/(tg|gg)$/, '');
      var exact = null, fallback = null;
      for (var i = 0; i < sets.length; i++) {
        var id = String(sets[i].id).toLowerCase();
        if (!sets[i].sym) continue;
        if (id === want) { exact = sets[i]; break; }
        if (id === parent && !fallback) fallback = sets[i];
      }
      var pick = exact || fallback;
      if (!pick) return;
      var img = document.createElement('img');
      img.className = cls;
      img.setAttribute('alt', '');
      img.setAttribute('decoding', 'async');
      symFallback(img);
      img.setAttribute('src', symbolAsset(pick.sym, cfg.lang));
      host.insertBefore(img, host.firstChild);
    }).catch(function () {});
  }

  function show(res) {
    if (!res) return;
    el.innerHTML = render(res);
    var tk = typeKey(res);
    if (tk) el.setAttribute('data-ll-type', tk); else el.removeAttribute('data-ll-type');
    var sym = el.querySelector('.ll-tcg__sym');
    symFallback(sym);
    if (!sym) patchSymbol(res, el.querySelector('.ll-tcg__hd'), 'll-tcg__sym');
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-in'); });
  }

  /* ---- set logo + set name next to the price in the buy panel ----
     Same sources as the card-details header: English set name from the product
     title (falls back to the API), Pokellector/TCGdex symbol. One Piece has no
     symbol art, so it shows the name (and set code) alone. ---- */
  function showSetByPrice(res) {
    var box = root.querySelector('[data-price-set]');
    if (!box) return;
    /* No card found. A brand-new English Pokémon set is not in TCGdex for the
       first days or weeks after release (30th Celebration, 16 Sep 2026: Mew ex
       152/128 and 158/128, Gengar ex 154/128), so the whole panel stayed hidden
       and these products lost the set line every other single shows by its
       price. The set name is already in the title, so show that on its own.
       The card details stay hidden until the card really resolves; misses are
       cached for a day, so that happens by itself once TCGdex adds the set. */
    if (!res || !res.card) {
      if (cfg.game !== 'pokemon') return;
      if (cfg.lang !== 'en' && !TAG_SET) return;
      var tn = preferredSetName('');
      if (!tn || /^(promo|promos|promo card|holo|reverse holo)$/i.test(tn)) return;
      var tsym = pkSymbol(tn);
      box.innerHTML = (tsym ? '<img class="pdp__setsym" src="' + esc(tsym) + '" alt="" loading="lazy" width="46" height="30">' : '') + '<span class="pdp__setname">' + esc(tn) + '</span>';
      box.title = tn + (TP.num ? ' (' + TP.num + (TP.total ? '/' + TP.total : '') + ')' : '');
      symFallback(box.querySelector('.pdp__setsym'));
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-in'); });
      return;
    }
    var c = res.card, name = '', sym = '', code = '', symCls = '', pre = '';
    if (res.game === 'onepiece') {
      name = c.set_name || TP.setName || '';
      code = c.card_set_id || '';
      /* The colour IS the card's identity in One Piece, the way ink is in
         Lorcana, and the buy box was the one place it never appeared. Same dots
         Lorcana already uses, so it needs no new markup or styling.
         optcgapi writes a dual colour as "Blue Green", space separated. */
      var opc = String(c.card_color || '').split(/[\/\s,]+/).filter(Boolean);
      if (opc.length) {
        pre = '<span class="pdp__setinks">' + opc.map(function (cl) {
          return '<span class="pdp__setink" style="background:' + opColor(cl) + '" title="' + esc(cl) + '"></span>';
        }).join('') + '</span>';
      }
    } else if (res.game === 'lorcana') {
      /* No set symbol art exists for Lorcana, so the ink colour stands in. */
      name = (c.set && c.set.name) || '';
      code = c.collector_number || '';
      var dots = inkDots(c, 'pdp__setink');
      if (dots) pre = '<span class="pdp__setinks">' + dots + '</span>';
    } else if (res.game === 'mtg') {
      name = c.set_name || '';
      code = String(c.set || '').toUpperCase();
      sym = mtgSymbolUrl(c.set);
      symCls = ' pdp__setsym--mtg';
    } else {
      name = preferredSetName(c.set && c.set.name);
      /* Same precedence as the card-details header: TCGdex's own set.symbol
         first (right language and print for the card we resolved), Pokellector
         only where TCGdex has none, which is the Japanese sets and every promo
         set. Its map is keyed by English set name, and names like Black Bolt
         and Pitch Black exist in both catalogues. */
      sym = (TAG_SET && pkSymbol(TAG_SET)) || symbolAsset(c.set && c.set.symbol, cfg.lang) || pkSymbol(name) || symbolUrl(c);
    }
    if (!name) return;
    var h = pre;
    /* Magic keeps a square box: Scryfall symbols are round icons on a light
       disc, and a landscape frame would leave them floating. */
    var symW = symCls ? 22 : 46, symH = symCls ? 22 : 30;
    if (sym) h += '<img class="pdp__setsym' + symCls + '" src="' + esc(sym) + '" alt="" loading="lazy" width="' + symW + '" height="' + symH + '">';
    h += '<span class="pdp__setname">' + esc(name) + '</span>';
    box.innerHTML = h;
    box.title = name + (code ? ' (' + code + ')' : '');
    var img = box.querySelector('.pdp__setsym');
    symFallback(img);
    /* Pokémon only: the other games either have no symbol art at all or, like
       Magic, get theirs from a source that always answers. */
    if (!img && res.game !== 'mtg' && res.game !== 'lorcana' && res.game !== 'onepiece') {
      patchSymbol(res, box, 'pdp__setsym');
    }
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-in'); });
  }

  /* ---- Overview copy, written from the resolved card ------------------------
     Nearly every product in this catalogue carries the same boilerplate body
     copy, so the Overview tab leads with what the card actually is, what it does
     and who drew it. Deliberately short (a lead line, the rules text, a byline);
     the full spec sheet is the Card Data tab. This runs in the browser, so it
     improves the page for shoppers but does nothing for search engines: those
     still need real copy saved on the product itself. */
  function aOrAn(w) { return /^[aeiou]/i.test(String(w || '').trim()) ? 'an' : 'a'; }
  /* Joins the descriptor words, dropping repeats: One Piece leaders come back with
     rarity "L" (Leader) AND card_type "Leader", which would read "a Leader Red
     Leader card". */
  function descOf(parts) {
    var seen = {}, out = [];
    (parts || []).forEach(function (p) {
      p = String(p == null ? '' : p).trim();
      if (!p) return;
      var k = p.toLowerCase();
      if (seen[k]) return;
      seen[k] = 1; out.push(p);
    });
    return out.join(' ');
  }
  function listWords(arr) {
    arr = (arr || []).map(function (x) { return String(x == null ? '' : x).trim(); }).filter(Boolean);
    if (!arr.length) return '';
    if (arr.length === 1) return arr[0];
    return arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1];
  }
  /* Flattens API text into one clean line: Lorcast's "%" paragraph marks, stray
     newlines, and the em / en dashes Scryfall uses in type lines and ability
     words (house copy style is hyphens only). */
  function tidy(s) {
    return String(s || '').replace(/\s*%\s*/g, ' ').replace(/\r?\n/g, ' ')
      .replace(/\s*[—–]\s*/g, ' - ').replace(/\s+/g, ' ').replace(/\s+([,.)])/g, '$1').trim();
  }
  function sentenceClamp(s, max) {
    s = tidy(s);
    if (s.length <= max) return s;
    var cut = s.slice(0, max);
    var stop = Math.max(cut.lastIndexOf('. '), cut.lastIndexOf('! '), cut.lastIndexOf('? '));
    if (stop > max * 0.45) return cut.slice(0, stop + 1);
    var sp = cut.lastIndexOf(' ');
    return (sp > 0 ? cut.slice(0, sp) : cut) + '...';
  }
  function aboutBlurb(res) {
    var c = res.card, lead = '', does = '', meta = '';
    if (res.game === 'lorcana') {
      var lname = c.name + (c.version ? ', ' + c.version : '');
      var ld = descOf([c.rarity, cardInks(c).join(' and '), listWords(c.type || [])]) || 'card';
      lead = lname + ' is ' + aOrAn(ld) + ' ' + ld + ' card from ' + ((c.set || {}).name || 'Disney Lorcana') +
        (c.collector_number ? ' (card ' + c.collector_number + ')' : '') + '.';
      var lst = [], lnums = [];
      if (c.cost != null && c.cost !== '') lst.push('costs ' + c.cost + ' ink');
      if (c.strength != null) lnums.push(c.strength + ' strength');
      if (c.willpower != null) lnums.push(c.willpower + ' willpower');
      if (c.lore != null) lnums.push(c.lore + ' lore');
      if (lnums.length) lst.push('has ' + listWords(lnums));
      if ((c.classifications || []).length) lst.push('counts as ' + listWords(c.classifications));
      if (lst.length) lead += ' It ' + listWords(lst) + '.';
      does = sentenceClamp(c.text, 260);
      if ((c.illustrators || []).length) meta = 'Illustrated by ' + listWords(c.illustrators) + '.';
    } else if (res.game === 'mtg') {
      var f0 = (c.card_faces && c.card_faces.length) ? c.card_faces[0] : c;
      if (c.layout === 'art_series' || c.set_type === 'memorabilia') {
        lead = String(c.name || '').split(' // ')[0] + ' is an art series card from ' + (c.set_name || '') +
          (c.collector_number ? ' (card ' + c.collector_number + ')' : '') + '.';
      } else {
        var md = descOf([MTG_RARITY[c.rarity] || titleCase(c.rarity || ''), f0.type_line || c.type_line]) || 'card';
        var mv = (c.cmc == null) ? '' : String(c.cmc).replace(/\.0$/, '');
        lead = c.name + ' is ' + aOrAn(md) + ' ' + md + ' from ' + (c.set_name || '') +
          (c.collector_number ? ' (card ' + c.collector_number + ')' : '') + (mv ? ', with a mana value of ' + mv : '') + '.';
        if (f0.power != null && f0.toughness != null) lead += ' It is a ' + f0.power + '/' + f0.toughness + ' creature.';
        does = sentenceClamp(f0.oracle_text, 260);
      }
      if (c.artist) meta = 'Illustrated by ' + c.artist + '.';
      var LEGA = [['standard', 'Standard'], ['pioneer', 'Pioneer'], ['modern', 'Modern'], ['commander', 'Commander']];
      var lgl = LEGA.filter(function (l) { return (c.legalities || {})[l[0]] === 'legal'; }).map(function (l) { return l[1]; });
      if (lgl.length) meta += (meta ? ' ' : '') + 'Legal in ' + listWords(lgl) + '.';
    } else if (res.game === 'onepiece') {
      var od = descOf([OP_RARITY[String(c.rarity || '').toLowerCase()] || c.rarity, c.card_color, titleCase(c.card_type || '')]) || 'card';
      /* Leader card names carry a trailing print number, e.g. "Roronoa Zoro (001)". */
      var oname = String(c.card_name || '').replace(/\s*\(\d+\)\s*$/, '') || cleanName(TP.name);
      lead = oname + ' is ' + aOrAn(od) + ' ' + od + ' card from ' + (c.set_name || 'the One Piece Card Game') +
        (c.card_set_id ? ' (' + c.card_set_id + ')' : '') + '.';
      var ost = [];
      if (c.card_cost != null && c.card_cost !== '') ost.push('costs ' + c.card_cost);
      if (c.card_power != null && c.card_power !== '') ost.push('hits for ' + c.card_power + ' power');
      if (c.counter_amount) ost.push('counters for ' + c.counter_amount);
      if (c.life != null && c.life !== '') ost.push('has ' + c.life + ' life');
      if (ost.length) lead += ' It ' + listWords(ost) + '.';
      does = sentenceClamp(c.card_text, 260);
    } else {
      var pset = TP.setName || (c.set && c.set.name) || '';
      var ppn = printedNumber(c), pnum = ppn.num, ptot = ppn.total;
      var pkind;
      if (isPokemon(c)) pkind = [stageLabel(c.stage), listWords(c.types || []), 'Pokémon'].filter(Boolean).join(' ');
      else if (c.category === 'Trainer') pkind = ((c.trainerType ? c.trainerType + ' ' : '') + 'Trainer').trim();
      else if (c.category === 'Energy') pkind = ((c.energyType ? c.energyType + ' ' : '') + 'Energy').trim();
      else pkind = c.category || 'card';
      /* TCGdex rarities come back as "Double rare" / "Illustration rare". */
      var pd = descOf([titleCase(rarityOf(c)), pkind]) || 'card';
      /* A Japanese card's own name is Japanese, and unlike ability / attack text it
         is never machine-translated. The English title name is the readable one. */
      var pname = (hasJP(c.name) && cleanName(TP.name)) ? cleanName(TP.name) : c.name;
      lead = pname + ' is ' + aOrAn(pd) + ' ' + pd + ' card' + (pset ? ' from ' + pset : '') +
        (pnum ? ' (card ' + pnum + (ptot ? '/' + ptot : '') + ')' : '') +
        (c.hp != null && c.hp !== '' ? ', with ' + c.hp + ' HP' : '') + '.';
      var pab = (c.abilities || []).map(function (a) { return a.name; });
      var pat = (c.attacks || []).map(function (a) { return a.name + (a.damage != null && a.damage !== '' ? ' for ' + a.damage + ' damage' : ''); });
      var psent = [];
      if (pab.length) psent.push('Its ' + (pab.length > 1 ? 'abilities are ' : 'ability is ') + listWords(pab) + '.');
      if (pat.length) psent.push('It attacks with ' + listWords(pat) + '.');
      var peff = (((c.abilities || [])[0] || {}).effect) || (((c.attacks || [])[0] || {}).effect) || c.effect || '';
      if (peff) psent.push(sentenceClamp(fxText(peff), 220));
      does = psent.join(' ');
      if (c.illustrator) meta = 'Illustrated by ' + c.illustrator + '.';
    }
    return { lead: tidy(lead), does: tidy(does), meta: tidy(meta) };
  }
  function showAboutCard(res) {
    var box = root.querySelector('[data-about-card]');
    if (!box || !cfg.aboutOn || !res || !res.card) return;
    var b = aboutBlurb(res);
    if (!b.lead) return;
    var h = '<p class="ll-about__lead">' + esc(b.lead) + '</p>';
    if (b.does) h += '<p class="ll-about__does">' + esc(b.does) + '</p>';
    if (b.meta) h += '<p class="ll-about__meta">' + esc(b.meta) + '</p>';
    box.innerHTML = h;
    box.hidden = false;
  }

  function showAll(res) {
    /* The "Card Data" tab starts hidden — reveal it only when a card actually
       resolves, so products with no card data never show an empty tab. */
    var cardTab = root.querySelector('[data-tab-card]');
    showSetByPrice(res);
    showAboutCard(res);
    if (res) {
      show(res);
      if (cardTab) cardTab.hidden = false;
    } else if (cardTab) {
      cardTab.hidden = true;
    }
    /* Market trend graph in the buy panel — Pokémon single cards only, and
       renderMarket itself only reveals it when our price beats the market. */
    /* Every game now, not just Pokemon: Scryfall, Lorcast and optcgapi all
       publish a market price, they just publish different shapes. */
    if (res && cfg.marketOn) renderMarket(res);
  }
  function resolveByGame() {
    if (cfg.game === 'onepiece') return resolveOnePiece();
    if (cfg.game === 'lorcana') return resolveLorcana();
    if (cfg.game === 'mtg') return resolveMagic();
    return resolveCard().then(function (res) { if (res) res.game = 'pokemon'; return res; });
  }
  var cached = cacheGet();
  if (cached !== undefined) { showAll(cached); return; }
  resolveByGame().then(function (res) {
    if (res && res.game === 'pokemon') {
      /* Owner opted to only show English-language card text: drop JP-only matches. */
      if (cfg.hideNonEnglish && res.lang !== 'en') return null;
      /* Otherwise machine-translate any Japanese ability / attack text to English. */
      if (cfg.translate) return translateCard(res.card).then(function (did) { res.translated = did; return res; });
    }
    return res;
  }).then(function (res) {
    cacheSet(res, !!res);
    showAll(res);
  }).catch(function () {});
})();
